import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('logo-gsmlg-dev')
class AppbarElement extends LitElement {
  static override styles = css`
    :host {
      display: inline-flex;
      justify-content: center;
      align-items: center;
    }
  `;

  @property({ type: Number, attribute: 'width', reflect: true })
  width: number = 200;

  @property({ type: Number, attribute: 'height', reflect: true })
  height: number = 40;

  override attributeChangedCallback(
    name: string,
    old: string | null,
    value: string | null,
  ) {
    super.attributeChangedCallback(name, old, value);
    this.requestUpdate();
  }

  override render() {
    return html`
      <svg
        slot="logo"
        width=${this.width}
        height=${this.height}
        xmlns="http://www.w3.org/2000/svg"
        xmlns:vectornator="http://vectornator.io"
        xml:space="preserve"
        stroke-linecap="round"
        stroke-linejoin="round"
        clip-rule="evenodd"
        viewBox="0 0 2000 400"
      >
        <g vectornator:layerName="layer1">
          <path
            fill="#3eed85"
            stroke="#3eed85"
            d="m238 247 4-1v-4h-2v-2c9.367 0 28.639-19.279 33-28 1.596 3.193.255 2 5 2v-4h-2c1.447-2.894.255-2 4-2 0-5.097 3.256-6 8-6v-5l4-1v-26h-2v-2h-2v-2h-4v-2h-2v-4h-4v-2h-2v-2h-4v-2h-2v-2h-2v-4h-2v-4h-8v-2h-2v-2h-2v-2h-2v-2h-2v-2h-10v-4h-2V86h-2c0-9.619 4.173-12 14-12 0 2.745.596 1.702-2 3l146 1v-2h12c0 1.202-1.943 1.8-2 3-.65 13.651 0 27.333 0 41h2c0 13.522-2 6.523-2 14-4.553 0-5.747 4.874-10 7 2.596 1.298 2 .255 2 3h-5c-5.057 20.228-27 9.836-27 38h2v2h2v2h4v2h2v4h2v2h2v2c5.53 0 4.699.796 6 6h4v2h2v6h2v2h2v2h2v2h2v2h6v6h2v2h2v2h2v2h2v4h2v6h2c0 21.333.646 42.676 0 64-.077 2.551-6.869 3.717-8 4v-2H244v-2h-4v-14h-2v-43Z"
          />
          <path
            fill="#b780f4"
            stroke="#b780f4"
            d="M593 317c3.193-1.596 2-.255 2-5-6.167 3.083-11.833 2.916-18 6-5.738-5.738-35.352 11.057-30-5-2.894 1.447-1.255 1-5 1v-2c-5.471 2.736-22.587-8.413-16-15h-4c1.827-5.482-8.296-10.184-10-17l4-2c-1.596-3.193-.255-2-5-2 0-2.745-.596-1.702 2-3-8.41-16.82-10.369-36.476-15-55l2-1c-3.193-1.596-2-.255-2-5h-2c0-8.561-8.138-33 4-33v-2c-5.55-1.85-2.869.046-4-9 2.745 0 1.404-.298 4 1 1.421-2.842.598-3.598 3-6-1.471-2.943-1.236-1.293 0-5-2.745 0-1.702.596-3-2 4.769-4.769-1.908-20 10-20v-5h-4c4-1.333 2.667 0 4-4h-2c1.333-2.666 1.214-4.607 4-6v3c3.567 0 10.599-3.199 12-6v3l6 1c0 8.752-8 11.379-8 20h4v2c-3.711 0-5.81 2.38-4 6-3.301 3.301-3.352 9.462-4 14l2-1c0 5.745 1.491 4.255-2 6v-2l-2 2c2.37 3.555.798 3 4 3v6h-4l-2-6c-7.641 3.821.971 34.795 2 42h2c0 3.799-.152 36 8 36 0 4.054.316 2.051-1 6h13v2h-11c-2.842 11.368 7.448 19.138 9 30h4l2 6h2v2c4.943 0 3.057-.943 6 2l2-1v2h4c-7.738 1.105-5.946-1.108-8 3h5l-1 3h3v2c3.167-1.056 4.069-1.466 7 0l1-3c1.124 4.495 1.244 6 6 6-1.471-2.943-.764-1.293-2-5 3.045-1.015 19.49 3.98 15-5l9 1 1-3c-2.59 1.295-3.41 1.295-6 0 6.125-6.125 10.559-1.78 17-5-5.821-1.455-5.797-1.986-7-8l2-1v2c3.006 0 3.253-2.063 7-3 0 5.248.648 7.59 2 13l-3 2h2l-2 4h2c0 9.215-2 4.057-2 14-5.377 0-4.906 2.523-11 1Z"
          />
          <path
            fill="#26adf1"
            stroke="#26adf1"
            d="M260 246v2h4v-4h-2c0-3.798 6.202-10 10-10v-3c6.413-1.603 3.722-5.43 10-7v-3c4.723-1.181 3.385.229 5-3 1.298 2.596.255 2 3 2v-4h-2c2.76-2.76 1.885-4 6-4 0-4.48 3.445-2.89 5-6 1.894 3.789.255 2 7 2v-4h-4c5.81-5.81 5.015-6.15 6-16h-2v-12h-2v-5l22-1v2c16.367 0 7.858-2 22-2v22h6v2h4v2h2v2h2v2h2v2h2v2h2v4h4v4h2v2h2v2h2v2h2v2h4v6h4v2h2v2h2v2h2v2h2v2h2v4h4c0 1.795-1.925 3.207-2 5-.652 15.653 0 31.333 0 47H254v-2h-2c0-9.442-7.661-44 8-44Z"
          />
          <path
            fill="#af70f4"
            stroke="#af70f4"
            d="M690 170c2.843-5.685-4.963-8.019-9-6 0-9.238-4.939-7.182-2-16h-3v-3l-2 1v-2h-6c1.384-4.151-.931-5.725-2-10 3.202 0 1.445.37 5-2l2 2c1.298-2.596 1-1.255 1-4h-3c3.166-1.583 3.013-4.994 7-3-1.29-2.58-2.089-5.266-3-8l-2 4c-1.281-3.843-.763-5-5-5 5.521-5.521 6.303-2.879 5-12l2 2c-1.371-2.743-.345-6 3-6v2c3.707-1.236 2.057-.529 5-2l-1-2c4.004-3.003 4.358-6.679 9-9l-1-2 2-2 2 1c2.943-2.943 1.057-2 6-2v3c7.315 0 13.616-5.677 22-4 0 6.11 1.741 10.753-5 13l3 1v3h-3l1-2c-5.793 0-7.268-1.195-9 4h3v4h-4v-4c-4.414 0-2.293-.707-6 3 3.193 1.596 2 .255 2 5-2.745 0-1.702.596-3-2-1.447 2.894-.255 2-4 2-1.688 10.128-13.452 28.71 3 32v2c3.708 0 1.588-2 6-2v4l-4 1c5.311 2.656 10.627 3.813 15 6-4.495 1.124-6 1.244-6 6h2v2c3.054 0 1.368-.211 5 1 0 3.795 3.809 14.383 8 6 7.799 3.899 14.657 9.828 23 14-1.298 2.596-1 1.255-1 4h3c0 4.185.682 4 5 4l2 6c4.296 0 5.309 6.544 6 10h7c0 5.345-.016 9.476 3 14-3.555-2.37-3-.798-3-4l-1 6h-2v-5c-2.629 1.315-3.245 2.378-6 1l3-2c-4.222-4.222-2.92 0-7 0 0-2.745.596-1.702-2-3-2.328 3.492-6 4.546-6 9 4.723 1.181 2.771 1.615 6 0v2c-3.708 0-1.588 2-6 2-1.333-4 0-2.667-4-4v-2h-2v-4c-5.563 0-4-1.933-4-8h-2l2-2c-2.143-4.287-3.872-8.745-6-13l-2 1v-2c-4.144 2.072-5.226 3.194-10 2v-2h-4v-2c-5.03 0-6.591-3.773-8-8h-6c1.56-3.121-.927-4.782-2-8h-4c-1.435-4.304.023-2.744-5-4v-2h-3Z"
          />
          <path
            fill="#edfaf8"
            stroke="#edfaf8"
            d="M388 128h-3c-1.157 4.627-3 3.734-3 8-4.628 0-10 2.793-10 8-5.745 0-4.255-1.491-6 2h2v2c-7.993 0-18 10.503-18 18h2v10h-2v-8h-26v-2h-20v-6h-4v-4h-6v-2c-5.204-1.301-6-.47-6-6h-4v-4h-6v-2h-2c0-1.938-6.062-8-8-8v-2h-2v-2h-2v-2h-4v-4h-4v-4h-4V93l52-1v2h84v34Z"
          />
          <path
            fill="#b071f5"
            stroke="#b071f5"
            d="M880 196c1.113 4.453 0 4.158 0 8h3c.623 4.982.532 11.597 2 16h3l1-6 1 2c0-3.877 3.902-19.196 2-23l4-1v-2h-2c4.966-2.483-.37-14 6-14 0-10.378 5.721-14.442 10-23h-2c1.447-2.894.255-2 4-2 0-3.745-.894-2.553 2-4l1 2c3.95-1.975.339-3.678 2-7-2.894 1.447-1.255 1-5 1v-2h-2v-7c5.017 0 3.983-4 9-4l1-6h-2c0-2.745-.596-1.702 2-3 0 3.887 4.425 7 8 7v2h2c1.325 6.626-4.18 12.91 4 17-2.891 2.891-4.391 2.827-3 7-3.205 1.603-2.136 5.542-3 9h4c-5.286 2.643-1.749 12.508-1 17l-2-5c-10.933 10.933-17.421 34.473-15 49-4.02 2.01-9.197 29.576-10 36h2v4h-4v-2c-1.937 3.874-1.005 4-6 4 0-3.954-1.734-9.533 0-13-10.727 0-6-9.7-6-17l-3-1c0-2.745.298-1.404-1-4l-1 4h-2l-1 5h2v6c-3.632 1.211-1.946 1-5 1 1.55-3.1 1.55-5.9 0-9l-3 1c-.978-5.866-1.464-9-8-9 0 3.985 2 6.924 2 11-9.212-1.842-2.589-11-8-11v-6h-4l1-3 2 2c2.667-1.333 1.667-.333 3-3h-6c0-4.242 1.066-6.737 0-11l3-2c-4.496-8.992-5-7.305-5-18l8-1v-4c-2.745 0-1.404-.298-4 1v-7l-3-1v-4c1.333 2.667.333 1.667 3 3 2.37-3.555.798-3 4-3-1.803 5.409.372 5 5 5 1.068 11.743 2.647 7.707 0 13 3.077 3.077 6.766 5 11 5Z"
          />
          <path
            fill="#ba83f5"
            stroke="#ba83f5"
            d="M1173 167c-1.88-3.76-9-5.745-9 0h-2c0 2.943-.47 1.529 2 4-2.18 2.176-3.77 4.886-6 6l2 1c-1.3 3.895-.25 2.255-3 5-2.49-2.491-1.88-3.638-3-7h-3l1-2c-4.42-2.208-.29-5.583-2-9l3-2c2.53 2.527 1.58 1.157 3 4 6.94-3.472-10.22-11.889 0-17v9c2.74 0 4 .024 4 3 5.43 0 4-2.68 4-8-2.95 0-2.37-1.685-5-3l1-2c-2.6-1.298-2-.255-2-3-2.75 0-1.7.596-3-2l2-2-1-2 2 1 2-2c-2.34-4.682-.47-6.4-2-11h2c1.43-4.304 1.26-1.977 0-7 4.42 0 10-7.419 10-11h-2c1.55-3.1 3.52-5.034 5-8l-2-1c3.31-6.628 10.76-10 18-10l-5-2c3.02-3.024 4.81-4.39 7 0 4.63-4.63 17.05-5 23-5l-1 2h7c0 2.66-1 4.206-1 7-3.75 0-2.55-.894-4 2l5 1v2h9v2c4.68 0 5.45 4 9 4v4h-2c0-8.687-26.99-12.026-30-6h10v2c-7.83 0-3.45 2-12 2v-2h-4l3-2c-4.06-1.352-3.14-3.136-6-6l-2 3c-11.89-3.963-16.47 9-8 9 0 8.335-6.59 8.466-5 18h2v2l-7-1c-1.83 10.984-8.02 27.926-4 40Z"
          />
          <path
            fill="#ad6cf4"
            stroke="#ad6cf4"
            d="M1568 302v-2c-4.7-1.568-5.04.082-7 4-8.9-1.271-9-3.023-9-12h-2l2-2-2-3c6.05-4.031 3.36-16.183 2-23 2.67-1.333 1.33-1.333 4 0v-2h3c0-11.028.49-6.041-1-15-2.4 2.402-3.16 1.579-6 3 0-9.989-1.97-8.016 4-11-3.19-1.596-2-.255-2-5h-2v-2h-2c1.15-2.294 2.85-3.706 4-6v2c2.27 0 5.15-2.049 8-3l1 2 1-2c-2.88-1.441-2.35-2.302-1-5-3.18-.796-6.07-1.535-9-3 6.54-9.815 11.68-12.342 21-17 0 2.74.02 4 3 4 0-3.241.17-6 4-6v-2h2v4h4c0-5.012 5.9-7.317 10-8l-1 3c5.37 1.788 5.56 2.128 8 7-3.82 1.908-3.82 1.297-5 6 2.94 1.471 1.29.764 5 2v2c-20.34 1.271-10.67 1.41-29 0-1.78 10.657 6.29 39.356-1 43h2c0 11.361-1 20.721-1 32l42 3c-4.75 0-2.81.596-6-1l-1 3c-5.87 0-10.84 6-16 6v-2c-2.94 0-1.53-.471-4 2h3v3c4.37 0 2.03.243 7-1 0 3.689-3.63 2.63-6 5 2.6 1.298 2 .255 2 3h3v2l-3 1 3 1v2h12c-3.14 6.289-13.97 2-21 2l1-2h-8v-4h-4l3-1v-2l-7 1 1-3c-2.89-1.447-2-.255-2-4-2.75 0-1.4.298-4-1-1.3 2.596-.25 2-3 2Z"
          />
          <path
            fill="#ba84f4"
            stroke="#ba84f4"
            d="M1222 306c-2.17-4.333-3.62-1.31-7-3-1.67 3.335-2.37 4.79-6 6l1-2c-6.85-3.425-4.06 7.814-3 11-14.26 0-22.18-5.061-34-9 3.29-.658 8.61-2.211 10-5-3.75 0-2.55.894-4-2l3-1c0-4.689 2.92-9-3-9v-2h-3c2.58-3.877 1.62-1.86 3-6 7.09 14.171 20.21 8.053 36 12l-1 3c2.89-1.447 2-.255 2-4 8.9-2.224 8.1-8 18-8-1.61-3.229-.28-1.819-5-3 0-11.686 3-18.902 3-29 6.81-2.27 4-5.507 4-12 1.14 7.973.94 18.345 4 26-6.17 3.087-2 .255-2 15h2c1.09 8.739-.2 5.596 2 10 8.34-4.17 30.57.713 18 7l1 2h-17l-1 3c-1.45-2.894-.25-2-4-2 0-2.745-.3-1.404 1-4-2.6 1.298-2 .255-2 3-3.56 0-3.2-2.781-4-6-1.76 3.52-.85 1.269-2 7h-2c0-5.081-4-5.081-4 0-2.94 0-1.53-.471-4 2Z"
          />
          <path
            fill="#b173f4"
            stroke="#b173f4"
            d="M1781 203c0-21.524-8.4-36.217-11-57h-2v-6h-2c1.61-3.229.82-1.277 2-6h-2v-6c-1.33.667-2.67 1.333-4 2v-2h-2v-10h-2v-6h-4c0-3.235-2.73-23.405-11-11l-1-5c-5.08 0-4.28 3-9 3-1.07 3.211-3 3.053-3 6h4c0 5.448-3.54 4.292-2 12h3v2l3 1v5c3.89 1.298 2.25.255 5 3-5.59 2.794-3.9 1.167-5 10 13.76 6.881 10 19.549 10 32h2v3h4v3c3.31-1.655 2.47-4.055 1-7 4-1.333 2.67 0 4-4 1.73 3.451 1.03 4.677 5 6v4h2v3c-3.95 1.316-1.95 1-6 1v-2c-3.75 0-2.55-.894-4 2h2c-1.43 4.304-.74 1.977-2 7h2v6h2c0 6.943-1.41 4.586 2 8l-1 2c7 0 5.59.83 8-4v2h3c0 3.178 1.39 3.306 4 2v3c2.94-1.471 1.29-.764 5-2Z"
          />
          <path
            fill="#a054f2"
            stroke="#a054f2"
            d="M1468 136c0-2.76-2.3-3.451-4-6 3.36 0 1.64-2 5-2 0-3.374.16-1.354-1-6h3l1 3c3.75 0 2.55.894 4-2l1 3c4.62 0 4.02-5.983 9-1-2.6 1.298-2 .255-2 3 4.3-1.435 1.98-1.256 7 0l-1 2c5.53 1.844 3.26 3.686 10 2v5c3.13 0 3.72 2.143 8 3 4.14-8.275 5.74 6.424 6 8h3v2h3c0 9.44 2.95 16.541 4 26h4v5l-1-2c-1.17 14.02-1.66 8.041 0 18l-3 1c-1.27-6.348.65-4.588-5-6l-1 3c-2.94 0-1.53.471-4-2-3.28 1.642-5.68 3.906-8 7 3.88 2.585 2.62.86 4 5-4.64 0-7.46-8.081-10-3-1.42-4.26-3.41-9.585 0-13v2l3-1-2-2 1-2h-3c0-2.745-.3-1.404 1-4l-2-2c3.77-7.539 9.75-.74 6-12h-2c3.96-1.979 4.05-3.1 6-7-4.33 0-8.95.012-13-1l-1 8h-2v-2h-2v-2h-2c3.18-3.178 2-1.057 2-7l-2 1v-8c-5.56 0-4.47-1.414-6-6h-2l2-1c-1.3-3.894-1.75-2.255 1-5l-2-2c-1.89 3.789-.25 2-7 2 2.94-1.471 1.76-.293 3-4h-2v-2c-3.2 0-1.45-.37-5 2h3c-3.55 2.37-1.8 2-5 2Z"
          />
          <path
            fill="#cdf9de"
            stroke="#cdf9de"
            d="M388 124h2l-1-32-138-1c-1.41 18.328-1.271 8.662 0 29l1-27 136-1v32Z"
          />
          <path
            fill="#9f54f3"
            stroke="#9f54f3"
            d="M1468 262c8.43 0 10.55-5 19-5-13.52-1.931-5-4.863-5-12 3 0 4.72-1 8-1l-2-4c2.83-2.825 6-5.278 6-9 6.03 0 2.68-.219 10 1-3.64-1.822-3.99-2.945-5-7 2.5.835 4.39 2 7 2v3c3.38-1.127 4-1.479 4-5 5.75-1.437 9.09-1.739 7-8 3.94-1.313 5-1.368 5 3h2v5h2c0 10.715-4.24 8.38-11 5l-2 9-8 1c0 7.357-.24 3.351 1 12-4.92 2.462-.49 5.372-7 7 3.67 1.836 3.99.985 6 5-3.91 3.913-11 10.023-11 16-3.75 0-2.11-.447-5 1l5 1v4h4v2h-6v-2h-2v-2c-3.75 0-2.55-.894-4 2h2v2c-14.2 0-10.6-3.606-15 3l-1-4c-4.3 0-2.59-1.295-6-3h3c1.21-6.034 1.54-3.387 0-8-3.75 0-2.55.894-4-2l2-2-2-2c1.84-3.682 3-3.241 3-8Z"
          />
          <path
            fill="#9d50f3"
            stroke="#9d50f3"
            d="M1139 304h-97c1.18-4.723.39-2.771 2-6-4.08-1.359-6.38.23-11 1-1.24-3.727-2.22-7.118-3-11-4.68 2.342-2 .255-2 10h-2c0-14.642 2-7.212 2-18 3.33-1.11 6.35-1.698 8-5l2 1c0-3.806 1.35-7.102 2-11 3.7 0 1.35.131 7-1-1.31 2.611-1.18 4 2 4-2.81 1.405-1.65 2.301-3 5h2l1 3c2.33-4.659 13.56-2.803 18-3 14.32-.637 28.67-.667 43-1-1.33 2.667-.33 1.667-3 3v-2c-5.49 0-14 .619-14 8 3.76.941 9 4.091 9-2l-2 1c0-5.569 9.57-3.688 13-4 1.61 4.83 3 2.344 3 8 6.92 0 5.11-8.297 15-5v2c2.75 0 1.7.596 3-2 .67 1.333 1.33 2.667 2 4-5.73 2.867-10.47 7.064-7 14l-5 1v-3c-1.24 3.707-.06 2.529-3 4l3 1v2c13.2 0 8.67-2.219 15 2Z"
          />
          <path
            fill="#c08ef6"
            stroke="#c08ef6"
            d="M831 142h-3v-2h-2c0-7.551 9-14.944 9-23 3.054 0 1.368-.211 5 1v2l2-1c0 2.745.298 1.404-1 4 3.035 0 7.524 4.048 9 7l-3 3c4.57-2.285 4.637 4.819 9 7-1.306 2.611-1.178 4 2 4v2h4c0 4.447 1.459 9.669 2 14h3c0 6.247 1.461 16 9 16 0 4.745 1.193 3.404-2 5 1.57 4.71.811 9.27 6 11v4h-4l-1-3c-4.943 0-3.057.943-6-2 2.247-4.494 1.196-9.607-1-14-4.265 2.133-5.456.367-4-4-3.202 0-1.63-.555-4 3l-2-2-1 3 3 1v7c2.596-1.298 1.255-1 4-1v4h-7c-.74 5.179-3 7.595-3 12-3.6-1.8-3.181-3.905-4-8h-2c0-11.374-.808-6.766 1-14h-3c2.142-4.283-.473-6.018 4-9l-1-4c3.748-1.874 1.691-4.856 1-9-4.391 0-4.367 2-8 2 0-6.548-1.592-21.796-8-25-3.839 3.839-4.216 2.919-3 9Z"
          />
          <path
            fill="#a259f3"
            stroke="#a259f3"
            d="M983 251c0-5.276-1.737-9.947-3-15h-2c0-5.002 2.852-7.408 4-12-6.034-1.207-4.463.612-6-4h-2v-2h-2l2-2c-8.16-10.88-11.345-25.726-14-39-5.143 0-6.19-5.948-7-10-4.28 0-29.575-2.787-14 5 2.471-2.471 1.057-2 4-2 0 4.668-3.846 6.846-7 10l3-1-1 2h2c0 2.48-2.52 5-5 5-1.462 4.386 1 12.808 1 18 3.556 0 4 .335 4 4h3c0 3.745-.894 2.553 2 4l-3 3c4.087 2.043 2 .255 2 8 6.054 0 3.419-.527 8 1-2.947 4.421-.115 7.23-2 11 4.552 0 8.713-.713 12-4 0 4.252-1.03 6.882 0 11h-3c-1.146 5.731.52 4.24-3 6 2.889 8.667 7.194 6.899 16 8 1.251-2.502 3.03-4.03 5-6 3.877 2.585 1.86 2.38 6 1Z"
          />
          <path
            fill="#b478f7"
            stroke="#b478f7"
            d="M688 283c0 3.665.444 4 4 4v2c3.418-1.709 5.573-.715 9-3 3.632 4.842 11 6.448 11 12l3-1c0-5.921 4.075-3.963 8-2l2-2c-2.37-3.555-.798-3-4-3l1-2c3.707 1.236 2.057 1.471 5 0v2c3.317 0 23-15.686 23-21l6-1v2h6c-1.288 3.863-.859 5.141 2 8-3.821 3.821-.584 6.861-7 9 0 4.524.499 4.875 5 6-5.938 4.751-3.816 2.224-7 7l4 2h-5v-2c-10.008 0-16.761 2.09-18 12-7.828 0-3.447 2-12 2-1.181-4.723-1.615-2.771 0-6h-4c1.298-2.596 1-1.255 1-4h-2v-3c-3.337 1.669-5.279 5.139-9 7v-2h-2v-2l-1 2-1-2c-7.888 5.916-11.119 3.284-24 4v-2c-6.266-1.566-6.826-6.413-12-9 5.412 0 7.58-.053 12-3l1 2c1.298-2.596 1-1.255 1-4h-2c0-5.445 2-2.09 2-9h4Z"
          />
          <path
            fill="#a55df4"
            stroke="#a55df4"
            d="M836 246c-7.782 0-2.994 15.284-4 23-1.627 12.474-8.711 23.422-14 34-5.84-.973-5.471-3-10-3 0-7.276.213-8.72-1-16l4-2-1-8 3-1c0-8.004 3-15.366 3-22 3.707-1.236 2.529-.057 4-3-4-1.333-2.667 0-4-4h-2c.674-5.394.194-12 7-12l-3-1c1.298-2.596.255-2 3-2-1.491-2.981.532-7.726 1-11h-2c0-6.897 4-9.265 4-14h-2c4.126-8.253-1.746-5.751 8-9-2.596-1.298-2-.255-2-3-12.029 0-5.605-33 4-33 9.363 28.088 2.246 55.423 4 87Z"
          />
          <path
            fill="#9c4ff2"
            stroke="#9c4ff2"
            d="M1376 186c3.18-1.591 1.4-4.201 5-6l-1-4h-4v-18c4.75 0 3.4 1.193 5-2h-2c3.78-3.784 4.09-7.029-2-5 1.13-4.538 1.93-9.861 4-14h-2c0-5.018.07-1.338-1-11h2v2h2c-1.25-7.47-1.91-4.187 1-10 2.59 1.295 3.41 1.295 6 0 0 3.375-.16 1.353 1 6l3-1c1.45 2.894 1 1.255 1 5 9.04 0 8 17.109 8 22h2v4h-2v-2l-2 2 1 2c-2.47 1.648-4.38 3.688-7 5 3.83 1.916 2.16 5.42-1 7 1.51 9.053 2.27 6 9 6 0 23.396 7.74 47.854 4 74-1.77-10.615-.86-3.978-2-20h-2v-7c-5.7 0-2.69.261-9-1-1.3 2.596-.25 2-3 2-1.29-3.864-1.05-4.684-5-6 0-2.943-.47-1.529 2-4-2.98-5.96-.24-7.81-9-10l1-2-2-2 1-2c-3.97-1.984-.78-6.351-2-10Z"
          />
          <path
            fill="#9644f2"
            stroke="#9644f2"
            d="M1662 314c2.76-2.76 1.89-4 6-4v-2c-5.42 0-14 1.344-14 8h-4l1-3c-5.5 0-6.91 4.617-15 3-3.35 6.71-18.42 1.316-25 0l1-2h-12c0-2.745.6-1.702-2-3 2.6-1.298 2-.255 2-3h-3v-2h-2c2.03-3.045 6-2.544 6-6-4.37 0-2.03-.243-7 1v-3h-3c2.47-2.471 1.06-2 4-2v2c4.65 0 13.29-5.291 17-9 15.04 7.52 44.55.945 64-1v2c4.09-2.046 4.63.743 3 4 2.75 0 1.7-.596 3 2 4.31-1.435 5.11-3.022 10-4-2.17 3.258-1 7.543-1 12 4.56 0 7.91 1.821 10 6-9.68 4.841-30.53 8.237-39 4Z"
          />
          <path
            fill="#b880f6"
            stroke="#b880f6"
            d="M1840 224c1.48-5.936-2.33-7.657-5-13-1.61 3.229-.28 1.819-5 3 1.41 4.221-.23 3.463-2 7l-1-3c-3.05 0-1.37-.211-5 1 1.19-2.376-.67-7.341-2-10 3.36-1.679 6.04-9.927 4-14l2-2 2 1c0-7.701 5.13-14.375 13-17 0-4.282-3.55-4.645-5-9h-2v-6h-2l1-2 2 1 2-2c-8.97-17.935 19.24-15.827 3-5h5v2c-5.9 1.965-4 5.221-4 10 1.87-3.735 6.78-7.889 11-10v4c4.89-.978 5.69-2.565 10-4-1.33 2.667-1.33 1.333 0 4-3.19 1.596-2 .255-2 5h2c-2.66 5.315 1.56 25-5 25-3.21 9.618-11 16.828-11 26h2v4c-5.31-2.655-2.75 4-8 4Z"
          />
          <path
            fill="#ad6df5"
            stroke="#ad6df5"
            d="M1844 144c3.98 0 5-6.624 5-10 3.75 0 2.55.894 4-2l2 1 1-2h-2c2.74-4.109.8-3 6-3 0-3.123-.33-7-4-7v-2c6.29-1.259 4.25-1.246 8-5-2.86-5.724 3.48-3.24 7-5l2 2c3.21-1.606 11-5.512 11 1 5.76 1.44 9.02 9.488 2 13 2.6 1.298 2 .255 2 3-4.3 0-2.59 1.295-6 3 3.19 1.596 2 .255 2 5h-4v-4c-4.13 4.126-.27 7.135-6 10 0-2.745.3-1.404-1-4-1.58 9.474-3 6.454-3 18h-2v-2c-4.3 2.151-3.7 12.752-4 16h-3c0-3.745-.45-2.106 1-5h-2c0-4.745-1.19-3.404 2-5-1.33-2.667-1.33-1.333 0-4-4.31 1.435-5.11 3.022-10 4v-4c-3.7 1.851-10.61 6.771-9 10h-2c0-8.436 1.71-5.121 4-12h-5c4.15-2.768 4-5.401 4-10Z"
          />
          <path
            fill="#a55df4"
            stroke="#a55df4"
            d="m1644 220 1-2h-7l1-2c-8.75 0-6.81-2.385-9 2-4.48-8.964-19.98-2-30-2v-2l6-1-2-1 1-2c-2.94-1.471-1.29-.764-5-2v-3c3.89-1.298 2.25-.255 5-3-1.73-3.451-1.03-4.677-5-6l1-3c2.74 0 4 .024 4 3 1.03-4.117 2.68-7 7-7-1.47-2.943-1.24-1.293 0-5 2.75 0 1.7.596 3-2 7.74 1.105 4.89 2.054 9 0v2h28c-1.45 2.894-.25 2-4 2-1.18 4.723-.39 2.771-2 6 2.67-1.333 1.33-1.333 4 0l1-3c1.88.938 12.13-.282 15-1l-1 2h5c0 2.943-.47 1.529 2 4l-4 3c3.8 0 1.38.248 7-2v3h-2l-1 3h2v3h2v2l-3 1c2.74.914 5.26 2.086 8 3-5.81 3.871-9.45 6-17 6v-2h-2v-2h-2v-2h-6l1-3c-3.16-1.582-5.94 1.471-9 3v-2c-4.3 0-6.62.852-8 5 7.37 0 4.06-.485 10 1v2h6c-1.14 2.276-7.65 4-10 4Z"
          />
          <path
            fill="#af6ef6"
            stroke="#af6ef6"
            d="m1052 249-2-1c-2.75 2.745-1.7 1.106-3 5h-3v-3c-2.33 1.163-4.64 5.275-6 8 6.49 3.245 1.34 12.641 0 18l-2-1c-2.85 2.85-1.48 1.216-4 5-2.6-1.298-1.25-1-4-1 0-7.329 3-13.917 3-20h-2c0-3.617 1-6.498 1-10h-2v-23h-2c0-18.643 4-35.677 4-54h2v4h2v-8c7.87 0 8.98 5.875 10 13 12.39 0 5.15 56.603 6 66h2v2Z"
          />
          <path
            fill="#ae6df3"
            stroke="#ae6df3"
            d="M1556 169c1.23-4.915.03-3.028 3-6l-2-3c-3.76 1.879-2.04 2.76-7 4v-12h-2c0-27.778.83-24.657 8-39h-3c4.77-1.59 8.64-3.213 14-5 0-7.322-2.38-8 7-8 0 3.202-.55 1.63 3 4l-3 2c1.54 4.613.79 1.966 2 8-8.44 0-4.35 13.062-4 18h2c0 19.042 2.65 39.425 0 58h-2v-2h-4c0-4.277-1.06-3.681 0-9-2.84 1.422-1.47.473-4 3-2.53-2.527-1.16-1.578-4-3-2.42 4.843-.95 2.946-4 6 1.3 2.596.25 2 3 2v2l3-1c-3.78 3.778-8.87 6.289-14 8 0-2.521-3.04-32.521 8-27Z"
          />
          <path
            fill="#b478f5"
            stroke="#b478f5"
            d="M1448 314c1.44-2.871 2.58-1.577 5-4-2.67-1.333-1.67-.333-3-3-4.65 1.162-2.63 1-6 1l1-2c-4.09 2.724-8.12 5.374-13 7l-1-2c-2.94 1.471-1.29.764-5 2 0-2.745.3-1.404-1-4l-3 2c-4.3-8.595 32.56-40.812 44-37v2h3v8h-3c3.62 1.809 6.12 3.238 8 7l9-3c-1.33 2.667-.33 1.667-3 3 2.6 1.298 2 .255 2 3-5.72 0-19.88 9.754-22 14h4v4c-8.49-2.124-6.55 4.137-14 6v-4h-2Z"
          />
          <path
            fill="#ac6af4"
            stroke="#ac6af4"
            d="M1615 115c-2.06-6.178.05-2.895-11-4 0-5.252-8-5.252-8 0l-2-9c-1.45 2.894-.25 2-4 2 0-2.745-.3-1.404 1-4h-2l2-2-3-1c7.25-3.623 12.86-2.628 21-1 0 4.745-1.19 3.404 2 5l-1 3c3.22-1.608 4-7.425 4-11h-2c1.36-2.713 3.64-4.287 5-7 18.48 2.64 37.33 0 56 0 0 3.563 1.88 6.65 3 10h2v2h-3v-3c-4.97 0-9.16 2-14 2l2 1c-8.06 16.126-37.74 1.616-48 17Z"
          />
          <path
            fill="#933ef1"
            stroke="#933ef1"
            d="m1382 231 2-4h-2c0-6.745-.89-4.211 1-8h-3c0-8.39 8.97-1.128 10 3 3.36 0 7.16-2 12-2 1.54 4.613 1.21 1.966 0 8h2c0 9.192-.12 15.509 2 24l-2 1c1.47 2.943.29 1.764 4 3 0 14.425-4.22 20.914-2 32-3.05 0-1.37.211-5-1l1-2c-4.94 0-8.67-1.332-4-6-2.86-1.429-3.88-3.562-7-2-2.39-5.978-1.43-3.297-3-8l-1 3c-2.31-4.615-7.68-4.321-11-1 0-5.606-.45-6.249-2-14 3.54-1.769 3-4.296 3-8 1.23 0 16-14.747 16-15h-3c0-4.054-.32-2.051 1-6-3.66 1.829-5.02 4.326-9 3Z"
          />
          <path
            fill="#b880f3"
            stroke="#b880f3"
            d="M752 94c-4.713 0-12.381-4.197-18-5-2.303 4.606-17.963-7.49 4-2 .994-3.977 6.077-13.846 10-6 5.578-2.789 1.255-1 14-1v2h2c1.491 5.963 1.779 6.756 8 8v2c2.745 0 1.702.596 3-2l1 4-2 1c2.248 8.992-2.208 22.375 0 29h2v4h-4c0-9.094-5.571-4.047-10-7-4.249-2.833-8.12-21.36-10-27Z"
          />
          <path
            fill="#c18ff6"
            stroke="#c18ff6"
            d="M750 228c4.412 0 2.292-2 6-2v-2c-3.229 1.615-1.277 1.181-6 0 0-5.431 3.531-5.296 6-9 2.596 1.298 2 .255 2 3 4.08 0 2.778-4.222 7 0l-3 2c2.755 1.378 3.371.315 6-1v5h2l1-6c3.679 7.357 6.019 12.192 7 22h2c1.348 16.171-4.274 42.274-14 52h2v4h-2v-2h-6l2-1-4-1c0-3.745.447-2.106-1-5 3.877-2.585 1.86-1.62 6-3-1.229-4.915-1.972-3.028 1-6-1.429-2.858-3.562-3.876-2-7l-6-1v-2h-4c0-7.165 4-5.49 4-13h-2c1.298-2.596.255-2 3-2 0-4.334-3.303-23.152-7-25Z"
          />
          <path
            fill="#a864f4"
            stroke="#a864f4"
            d="M1052 168h-2c-1.76-5.284-2.1-25-5-25 3.23-1.615 1.82-.277 3-5h-2v-8l-3 2 1-2c-2.6-1.298-2-.255-2-3-1.47 2.943-.76 1.293-2 5h-4l-1-3 3-1v-7h-2c1.38-2.769 1.38-5.898 2-9-18.95 0-10 30.514-10 42-1.39-15.326-12.48-61.381 6-66-1.27 3.806-.24 4.27 1 8 3.55-2.37 1.8-2 5-2 0 8.903-.9 3.69-3 10l-2-3c-.67 2-1.33 4-2 6 7.1-2.368 2.6 5 9 5v8c2.75 0 1.7.596 3-2 0 16.825 9.97 32.202 7 50Z"
          />
          <path
            fill="#b479f4"
            stroke="#b479f4"
            d="M939 132c6.024 3.012 3.181 7.09 9 10l-2 2h3c0 5.709 3.947 12.679 5 19 7.454 0 3.189 7.567 5 13h5c0 9.717 1.166 13.997 2 24-1.566-7.83-4.439-15.196-6-23-5.143 0-6.19-5.948-7-10-4.28 0-29.575-2.787-14 5 2.471-2.471 1.057-2 4-2 0 4.668-3.846 6.846-7 10l3-1-1 2h2c0 4.34-4.519 4.84-8 6 0-17.846-.062-40.875 7-55Z"
          />
          <path
            fill="#bd86f8"
            stroke="#bd86f8"
            d="M511 276c-7.078-10.616-9.711-23.824-11-38h-2c0-17.825-5.009-37.082-7-55l3-1c0-3.506-.589-6.822 1-10 2.471 4.943.586 3.529 5 5v2h-4c0 10.698-1.916 21.502 0 33h2c0 4.745-1.193 3.404 2 5-7.493 3.746 10.107 50.214 13 56-2.596 1.298-2 .255-2 3Z"
          />
          <path
            fill="#ae6ef4"
            stroke="#ae6ef4"
            d="M1491 128c-4.72-1.181-2.77-1.615-6 0l-1-2 2-1c-4.87-2.437-4.7-1.149-9 1v-4c-1.61 3.229-.28 1.819-5 3-1.24-3.707-.06-2.529-3-4-1.15 5.731-1.76 3.48 0 7-5.42 0-8.36.66-15-1v-3l-6-2v-2h-2v-2h-4v-2c-3.56 0-4-.335-4-4h-2c2.37-3.555.8-3 4-3v-5l2 1c0-4.107 2.89-9 7-9v-2c5.16 0 7.78 1.13 13 2v2l6 1c-2.6 1.298-2 .255-2 3h7c0 3.858 5.9 6.6 7 11 2.94 0 1.53-.471 4 2l-2 1h12v4h2v2h2v2h2v2h2c-4.06 0-11-4.9-11 2Z"
          />
          <path
            fill="#ab68f4"
            stroke="#ab68f4"
            d="M1844 144c3.98 0 5-6.624 5-10 3.75 0 2.55.894 4-2l2 1 1-2h-2c2.74-4.109.8-3 6-3 0-3.123-.33-7-4-7v-2c6.29-1.259 4.25-1.246 8-5-2.86-5.724 3.48-3.24 7-5l2 2c3.21-1.606 11-5.512 11 1 3.6.901 7.14 1.712 5 6h2c0-8.834-1.45-10.339-4-18-12.16 0-16.87-4.379-20 5-7.68-5.123-9 5.4-9 11h-5c-1.05 11.566-7.03 16.198-9 28Z"
          />
          <path
            fill="#f7effb"
            stroke="#f7effb"
            d="M1581 288c-9.51-1.902-6.62-25.152-4-33h-2c7.72-3.862 2.02-31.905 0-42 17.01 0 8.68-.36 25 1v2c-15.23 0-7.24 2-21 2 0 12.671 4.67 26.667-1 38l2 2-2 1c4.33 2.167 0 7.089 0 11h2c0 3.884-2 9.394-2 15l3 1v2Z"
          />
          <path
            fill="#923bf1"
            stroke="#923bf1"
            d="M986 276h-2v-2h-2v-4c-5.401 2.7-5.354.532-9 6h3v5l-1-2-1 3h4v2h2v4c5.351 0 3.774-3 8-3 0 15.205-1.436 9.145-16 14v-2l-6 1c-1.236-2.472-1.472-3.736-4-5 1.472-2.943.764-1.293 2-5h-6c0-6.947-3.97-20.059-1-26h-3v-2h-2c0-12.064 2-5.941 2-13 7.406 7.406 5.537 7.442 18 9 1.251-2.502 3.03-4.03 5-6l3 2 2-2c2.132 10.658 3.189 12.21 4 26Z"
          />
          <path
            fill="#bb84f5"
            stroke="#bb84f5"
            d="m604 302 2-4h-2c4.598-4.598-.777-9.668 1-15h-6c-1.083-15.161 4.777-30.893 1-46h-3l6-1v-8l1 6c6.64 0 4.253 2.758 6 8 2.745 0 1.702.596 3-2l1 3c2.745 0 1.702.596 3-2 0 3.783 2.51 5.98 1 9 10.911 5.456-6.116 35.652-4 42h4v4h-7c-1.304 5.215-1.989 6-7 6Z"
          />
          <path
            fill="#b983f5"
            stroke="#b983f5"
            d="M1174 308v-2h-4v-4l-6-2v-2h-2v-3h-2c0-2.745-.3-1.404 1-4-5-2.498-1.93-.258-3-11h-2c1.55-4.644-1.06-6.685 0-12h4v2c4.05 0 2.05-.316 6 1 0-3.358 2-1.642 2-5h-2c2.47-2.471 2-1.057 2-4 14.32 3.58 6.77 26.752 27 29-3.43.858-6.54 3-10 3-1.5-4.507-3.48-5.221-6-9-1.42 2.843-.47 1.473-3 4l3 1v2c6.15 0 3.5 8.252 0 10 1.45 2.894.25 2 4 2-1.4 2.809-5.86 4-9 4Z"
          />
          <path
            fill="#994af1"
            stroke="#994af1"
            d="M1377 297c4.06-6.097 13-.524 13-9-3.61 0-6.34-1.267-10-2v-2h-2c0-7.043-3-11.556-3-20 2.95 1.969 4.77 3.116 1 5l1 2 1-2 8 1v2l2-3c2.98 8.944 3.42 5.71 10 9-2.55 3.832-2 1.798-2 6 3.37 0 1.35-.162 6 1-1.33 2.667-1.33 1.333 0 4l-3 1c0 2.943.47 1.529-2 4 1.3 2.596.25 2 3 2v3c2.94 0 1.53-.471 4 2l-2 1h4c0 5.054-.42 2.735 1 7-2.53-2.527-1.16-1.578-4-3-2.97 2.972-1.09 1.771-6 3 2.37 3.555 2 1.798 2 5-3.89-1.946-9 2.324-9 6-24.72 0-4.93-7.724-8-20-2.95 0-2.37-1.685-5-3Z"
          />
          <path
            fill="#b57af5"
            stroke="#b57af5"
            d="M1386 322v-2h4c0-5.22 5.64-6 10-6l-2-4c3.78-2.523 2.15-1.15 5-4 2.67 1.333 1.67.333 3 3 1.43-4.304 1.26-1.977 0-7 6.28 0 10.99-1 18-1-2.48 1.242-3.01 3.009-5 5 2.41 3.621 1.46 1.925 3 5l3-2c0 5.15 2.35 4.433 6 2l1 2c4.87-2.436 8.64-4.091 13-7l-1 2c3.2 0 1.45.37 5-2 1.23 2.467 2.77 2.533 4 5-3.91 1.957-10.25 3.753-5 9h-3v-2c-8.83 0-28.93 5.643-39 9v-2h2c0-5.966-4.69-4.153-9-2v-3c-4.75 0-3.4-1.193-5 2l-1-2c-2.35 1.175-4.44 1.148-7 2Z"
          />
          <path
            fill="#d8b9f8"
            stroke="#d8b9f8"
            d="M1796 256c2.7 1.352 3.14 0 6 0 0-6.353-.92-9.159 2-15 1.33 2.667.33 1.667 3 3 1.48-2.962 2.56-5.116 4-8 .99 7.901 1.62 6.754-1 12h2c0 5.135 1.22 6.174-2 11 5.02 1.256 3.57-.304 5 4 4.05 0 2.05-.316 6 1 0 4.169-2.32 9.223-3 14l-1-6c-.85 8.463-.93 8.778-3 15 3.24 1.619 3.24 4.381 0 6 3.79 1.894 2 .255 2 7h-2v-4c-3.2 3.197-4 3.167-4 8h-4c0-2.943 2-3.057 2-6h-2c0-4.225-.11-7.218-2-11l2-2c-6.82-6.816-2.75-13.753-7-18 2.47-4.949-3-6.697-3-11Z"
          />
          <path
            fill="#c292f7"
            stroke="#c292f7"
            d="M1821 264c-3.95-1.316-1.95-1-6-1-1.33-4 0-2.667-4-4 1.24-3.713 2.24-7.282 1-11h-2c2.68-5.366 2-4.807 2-13 3.2 0 1.45.37 5-2-3.95-1.976-2.09-6.046 2-4 0-4.046-2.51-2.455-1-7h2c-1.18-3.536-.62-4.755 1-8 2.41 3.62 2.54 1.925 1 5 3.05 0 1.37.211 5-1v3l3-1-1-2 2-1-1-3c4.72-1.181 3.39.229 5-3 0 4.064 1.28 5.761 5 7 0 3.054-.21 1.368 1 5-3.23 1.615-1.82.277-3 5h2c0 9.236-.27 3.541-3 9l-1-3c-7.62 3.81-12.31 21.917-15 30Z"
          />
          <path
            fill="#a966f1"
            stroke="#a966f1"
            d="M525 121v-3c-4.631 2.315-7.898 4.724-13 6v-6c3.247 0 4.547-2 8-2l1-4 1 2 2-5 3 1c-3.024-1.512-2.467-2.822-6-4 3.736-7.471 12.355-13.71 15-19 2.035 4.07 6.023 2 10 2 1.236 6.178 2.414 4.057-2 7 3.423 0 6.193 3.29 8 6-3.769 0-8.163.325-10 4h2c0 5.745 1.491 4.255-2 6v-2h-2v-2c-2.358 4.717-4 4.176-4 10h2c0 6.446-2 2.834-2 10h-4v-6c-3.7 0-1.346.131-7-1Z"
          />
          <path
            fill="#af70f5"
            stroke="#af70f5"
            d="M874 284v-7l8-2c-4.564-2.282-4.864-12.271-3-16h-4c2.37-3.555 2-1.798 2-5-4.86 0-5.648 2-11 2v-6c3.235 0 5.382-1.236 7 2 3.6-4.8 1.333-4 6-4-2.202 4.404-1.092 1.261 0 10 2.536-3.804 7-2.587 7-8 3.785 0 6.638 1.319 10 3-2.099 4.197-.74 8.561 0 13h4v2h4v12h-2v-2c-2.527 2.527-1.578 1.157-3 4-1.593-4.78.62-9.76-2-15l-1 21c-2.745 0-1.404.298-4-1-2.054 4.108-.262 1.895-8 3v-2h-2c0-3.178-1.389-3.306-4-2v-2h-4Z"
          />
          <path
            fill="#d1acf8"
            stroke="#d1acf8"
            d="M707 86v-2h-3c4.797-4.797 7.661-4 15-4 0 2.745.596 1.702-2 3 5.989 0 10.991-4.005 17-1 1.881-3.762 5.602-4 10-4-3.488 1.744-5.077 5.308-6 9-3.321-1.66-7.399-2.56-11-4-2.555 3.832-2 1.798-2 6 4.612 1.537 1.966.793 8 2l1-2c15.904 2.272 15.069 3.137 22 17-2.894-1.447-1.255-1-5-1l-1-3h-3v-2h-5v-2c-7.043 0-13.977-1.298-21-2 .711-4.267 1-6.912 1-11-4.815-.963-10.37-.158-15 1Z"
          />
          <path
            fill="#9540f4"
            stroke="#9540f4"
            d="M1045 143c3.23-1.615 1.82-.277 3-5h-2v-8l-3 2 1-2c-2.6-1.298-2-.255-2-3-1.47 2.943-.76 1.293-2 5h-4l-1-3 3-1v-7h-2c1.38-2.769 1.38-5.898 2-9-19.55 0-10 32.983-10 44h2c0 8.026-2 2.026-2 14h2v2h2v4h2v-8c7.08 0 4.7 1.696 9 6l2-4 3 1c0-5.159 1.04-28-3-28Z"
          />
          <path
            fill="#f9fefb"
            stroke="#f9fefb"
            d="M408 308v2c-46.679 0-114.757 4-154 4v-2c-3.229 1.615-1.277.819-6 2v-4c-3.745 0-2.553-.894-4 2h2c0 3.564-2.781 3.195-6 4 0-1.578-1.179-7.925 3-8 54.991-.982 110 0 165 0Z"
          />
          <path
            fill="#b981f4"
            stroke="#b981f4"
            d="M1794 238h-2v-5l-2 3c-1.33-2.667-.33-1.667-3-3-1.56 3.122-3 3.258-3 7-3.97 0-4.03 2-8 2v-2h-2v-5h-2c0-4.262 3.09-4.184 5-8l-3 1v-2c-6.11 3.054-2.94-4.816-4-8h-3l1-4c-4.3-2.148-4.56-7.685-6-12 6 0 4.81.385 7-4v2h3c0 3.178 1.39 3.306 4 2v3c3.19-1.596 1.25-1 6-1 0 5.191-.43 4.477-5 6l1 7c6.23-1.557 3.67-8 10-8 1.61 9.674 3.62 19.474 6 29Z"
          />
          <path
            fill="#c596f7"
            stroke="#c596f7"
            d="M1776 250c1.41-2.822 4-4.358 4-7h-5l-1-3c7.62 3.047 3.62 0 10 0 0-3.796 1.81-4.427 3-8 1.59 3.177 3.8 3.408 5 7l-5 1 3 1-3 2h3c-3.51 1.757-3.81 5.44-5 9h2c1.26-5.023-.3-3.565 4-5 0 3.166 2.19 5.761 3 9l2-1c0 4.621 2.79 6.57 5 11l-2 1c3.11 3.111 2.66 3.559-1 6l-1-4h-2c-1.4 4.914-.17 15-7 15l2-2c-2.63-5.264-2.73-3.355-4-11l2-1c-4-1.333-2-1.333-6 0 0-4.511 2.91-8.645 4-13-4.05 0-2.05.316-6-1v-5l-4-1Z"
          />
          <path
            fill="#913af3"
            stroke="#913af3"
            d="M1374 90h-2c1.24-2.474 6.07-4 9-4 0 9.31 15.51 6.26 20 13 2.92-4.387.8-3 7-3 0 3.644-1.57 8.548-2 12l5 1c-5.86 1.466-5.53 5-12 5l-1 3h2v5h-2c0-3.054.21-1.367-1-5h-3v-2l-2 1c.67-1.333 1.33-2.667 2-4-3.94 0-2.29-.707-5 2l-1-8c-4.85 0-14-12.821-14-16Z"
          />
          <path
            fill="#ab6af2"
            stroke="#ab6af2"
            d="M540 89c1.471-2.943 1.236-1.293 0-5h-3c2.58-1.29 5.266-2.089 8-3 1.315 2.63 3 2.049 3 5 4.412 0 2.292-2 6-2l-1-3c9.29-.387 37.859-4.422 43 11l-3 1c2.745 2.745 1.702 1.106 3 5-3.641 1.82-2.224 6-8 6v-2c-4.264-1.066-5.736-2.934-10-4v-2c-8.014 0-25.064 4.468-34 0 3.179-3.178 2-1.057 2-7h-6Z"
          />
          <path
            fill="#9947f3"
            stroke="#9947f3"
            d="M1263 294c-9.45-6.3-12.27-4.364-21 0-2.2-4.404-.91-1.261-2-10h-2c0-18.821 2-8.886 2-20h-2c0-4.466 1.1-6.611 0-11 11.68-7.789 24.52-6.437 29 7l-6-2c0-3.445.33-6.336-3-8l-2 3 2 2-2 2c5.31 2.654-3 13.829-3 19h3v-3l4-1c2.93 7.325 3 14.175 3 22Z"
          />
          <path
            fill="#bf90f3"
            stroke="#bf90f3"
            d="m1678 212 3-1c-3.18-1.061-4.64-1.638-7-4 2.6-1.298 2-.255 2-3h-2v-3h-2v-2l3-1v-2c-5.05 0-2.74-.422-7 1 2.53-2.527 1.16-1.578 4-3-2.19-4.385-1-4-7-4l1-2c-4.41 0-8.79-1.21-12 2l-2-2c-2.65 3.973-2.37 2.184-6 4 1.45-2.894 1-1.255 1-5 6.58-.658 12.46-1 19-1l-2-1c7.82-.488 20-5.082 20 5h2c0 5.745-1.49 4.255 2 6l-2 2 3 1c0 3.745.89 2.553-2 4l2 1-2 1 4 2c-2.64 1.321-5 1.747-5 5h-8Z"
          />
          <path
            fill="#a45cf4"
            stroke="#a45cf4"
            d="m1498 199 2 3c2.05-4.108 6.45 1.225 10 3-1.3-3.895-.25-2.255-3-5 2.54-5.076 5.55-7.727 11-5v-2h5l1 5h2c-.97 9.685 1.17 17.679 0 27h-2v-5h-2v-3c-2.75 0-1.4.298-4-1-1.18 4.723-1.61 2.771 0 6-5.32 2.66-7.67 1.364-9 8h-3v-3c-3.63 0-3.35-3.326-8-1 2.08 3.127 2.85 3.423 6 5-7.36 1.226-4.03 1.492-10 0 0-9.857 4-14.102 4-25h-2c1.87-3.739-.81-2.778 2-7Z"
          />
          <path
            fill="#c79bf5"
            stroke="#c79bf5"
            d="M1592 314c-4.48 8.964-19.99 1.523-30 2 .67-1.333 1.33-2.667 2-4h-2c-2.55-7.646-12-1.669-12-12h-2v-7l4-1c0 9.79.08 10.726 9 12 1.96-3.918 2.3-5.568 7-4 0 5.849 2.56 6.221 4 12h6v2h14Z"
          />
          <path
            fill="#d3b1f4"
            stroke="#d3b1f4"
            d="M980 298v6c-4.723-1.181-2.771-.385-6-2l1-2c-6.55-.728-13.375-4.813-19-2v-2c-1.447 2.894-.255 2-4 2v-4h-2c0-12.116 1.951-4.917 3-28 1.812 9.062 7.387 12.452 5 22h6c0 3.202.37 1.445-2 5 2.528 1.264 2.764 2.528 4 5 8.014-1.336 5.986 1.336 14 0Z"
          />
          <path
            fill="#9542f2"
            stroke="#9542f2"
            d="M1550 203h-2v-7c5.91 0 9.83-4.416 15-7h-4v-2c-5.01 0-1.76-4.98-1-8 2.86 0 3.71.425 5 3 3.62-2.413 1.93-1.463 5-3 0 5.66-3.27 9 4 9v2c2.25 0 10 5.435 10 8-4.31 0-5.24 2.294-4 6h-2c0-2.745.3-1.404-1-4-5.99 5.99-25 21.378-25 3Z"
          />
          <path
            fill="#b376f4"
            stroke="#b376f4"
            d="M1406 108c0-6.713.23-6.69 2-12-5.75 0-3.51.745-7-1 5.04-2.518 25-1.864 25 5 3.44 0 5.59-1.147 9-2v-2h-4c2.63-5.266 5.84-5.16 10-1 3.79-1.894 1.25-1 8-1v2c-6.08 0-4.48 9-10 9l1 4c-2.94 0-1.53-.471-4 2 2.89 1.447 2 .255 2 4h2c-10.95 0-15.01-5-24-5l2-1c-8.65-1.236-4.64-1-12-1Z"
          />
          <path
            fill="#9b4bf3"
            stroke="#9b4bf3"
            d="M670 296v-2h-4v-2l-3-1 1-3h-2v-6c5.525-1.842 1.842-4.921 6-7 0 3.745.447 2.106-1 5 4.265-1.422 1.946-1 7-1-1.863-2.795-1.297-4.649-4-6l1-3c5.054 0 2.735.422 7-1 3.16 6.321 6.289 3.446 8 12 10.427 0 5.436-.733 15 2-8.936 1.117-6.1-.9-10 3v-3l-6-1c-.973 5.84-3 5.471-3 10h2c0 2.745.298 1.404-1 4l-1-2c-4.713 2.357-6.873 3.709-12 2Z"
          />
          <path
            fill="#cfa8f5"
            stroke="#cfa8f5"
            d="m1381 113 2 1c-1.51 4.526-1.85 8.925-1 14h-2c0-5.856-11.47-16.354-3-22l-1-3c-3.79 1.894-1.25 1-8 1 0-7.819 3.65-10-6-10v-2h-2c0-12.437 13-.912 13 4h3v2h2v2c5.43 0 12.14 9.953 3 13Z"
          />
          <path
            fill="#ba85f3"
            stroke="#ba85f3"
            d="M848 183c1.447-2.894 1-1.255 1-5h-3c2.142-4.283-.473-6.018 4-9l-1-4c3.748-1.874 1.691-4.856 1-9-4.391 0-4.367 2-8 2 0-6.548-1.592-21.796-8-25-5 5-4.175 7.475-2 14h2c.69 3.452 3.449 7.102 2 10h2v3c3.054 0 1.368-.211 5 1-1.362 5.446-1.615 2.771 1 8l-2 1c1.068 4.27 3.405 9.107 6 13Z"
          />
          <path
            fill="#b67df1"
            stroke="#b67df1"
            d="M1382 232c-5.31-2.653-8.04-22.109-10-28h-2c0-17.319 2-6.697 2-27h2c2.33 6.986 2 11.597 2 18h2c-1.3 3.894-1.75 2.255 1 5l-1 2c5.74 0 7.51 2.014 10 7l-2 1 1 2c-2.47 2.471-2 1.057-2 4-3.4-1.701-3.89-.342-5 3h3c-1.89 3.789-1 1.255-1 8h2c0 3.202.37 1.445-2 5Z"
          />
          <path
            fill="#c99ff6"
            stroke="#c99ff6"
            d="M1170 208h-2v-2c-2.42 2.416-2.8 2-6 2 1.34-2.687 5.47-8 0-8 1.45-2.894.25-2 4-2-4.68-2.34-1-4.991-3-9-5.96 2.979-12.34.67-3-4l-2-2c.67-1.333 1.33-2.667 2-4l-2-1c1.75-3.494 3.31-4.306 6-7l-3-2c1.3-2.596.25-2 3-2 0-3.887 7.76-5.087 8-2 .64 8.309.3 16.672 0 25a433.022 433.022 0 0 0 0 31c-5.9-5.896-2-3.66-2-13Z"
          />
          <path
            fill="#b67df3"
            stroke="#b67df3"
            d="m943 134-4-2c-1.181 4.723.229 3.385-3 5-2.848-5.695 4.244-14-4-14v-2c-2.843 1.422-1.473.473-4 3l-4-2-2 2c-2.596-1.298-2-.255-2-3-2.596 1.298-2 .255-2 3h2v5c-4.392 1.098-5.868 3.623-10 5v-4h-2c2.471-2.471 1.057-2 4-2l1-4h2l-3-1c2.572-5.144 13.114-13.943 19-11 2.707-2.707 1.057-2 5-2v2c6.238 0 4.937 1.623 6 8h2c0 5.414.943 3.057-3 7 2.447 4.894 2 2.509 2 7Z"
          />
          <path
            fill="#d2b0f5"
            stroke="#d2b0f5"
            d="M874 284h4v2c2.611-1.306 4-1.178 4 2h2v2c4.519 0 8.327-3.837 12-2l1-21c2.649 5.299 3.067 13.201 5 19h2v6c-8.126 0-8.245 8.189-17 6v-3c-6.369 0-5.652-5-13-5v-6Z"
          />
          <path
            fill="#af72f3"
            stroke="#af72f3"
            d="M1380 100h-2v-2h-2v-2h-3c0-2.43-4.36-8-7-8v-3c8.05 0 4.79-.738 10 1 4.58-9.163 20.3-6.701 27 0 4.19-2.094 4.41-2 10-2v2c-4.23 0-11.48 2.478-14 5 2.42 2.423 1.13 3.564 4 5l-2 3c-3.73-5.592-25.57-15.853-29-9h2v3c3.71 0 6 3.39 6 7Z"
          />
          <path
            fill="#a15bf0"
            stroke="#a15bf0"
            d="M1232 225c0-16.033 16.47-24.533 30-11l-2 1 3 1c0 3.88-2 5.741-2 9-6.33 0-3.58 6.965-3 11h-2v-8c-8.77 0-15.66-.22-24-3Z"
          />
          <path
            fill="#bd88f5"
            stroke="#bd88f5"
            d="M1124 302v-2h-3c.67-1.333 1.33-2.667 2-4 1.6 3.193.25 2 5 2 0-3.361 1.52-5.956 0-9 3.78-2.519 4.49-4.498 9-6-2.94-1.471-1.76-.293-3-4-1.3 2.596-.25 2-3 2v-2c-4.18 0-5-.819-5-5 13.29 4.431 20.59-1.444 23 13h-2l3 1c-1.75 5.236-1.15 1.957 0 10l-2-1c-2.39 11.926-13.98 5.835-24 5Z"
          />
          <path
            fill="#fffffe"
            stroke="#fffffe"
            d="M256 314h144v2c-36.148 0-106.424 4-146 4 0-4.412 2-2.292 2-6Z"
          />
          <path
            fill="#bd86f7"
            stroke="#bd86f7"
            d="M1052 146c0-7.125-4.2-22.395-7-28-1.3 2.596-.25 2-3 2v-8h-3c0-2.74-.02-4-3-4v-2l-3 1c0-3.795-.25-1.381 2-7l2 3c1.33-2.667.33-1.667 3-3 1.89 7.56 14.79 25.412 10 35h2c-1.85 5.55-1.13 1.954 0 11Z"
          />
          <path
            fill="#ba84f6"
            stroke="#ba84f6"
            d="M1157 214v-2h-2v-2h-2c0-4.745.6-2.808-1-6 3.46-1.732 4.63-21.816-3-18 3.89-3.89 6.23-4.384 11-2-1.54 3.075-.38 1.586-4 4 1.26 5.023.57 2.696 2 7 3.18 0 3.31-1.389 2-4l3-2c1.64 3.282-1.69 8 3 8-3.71 1.236-2.53.057-4 3 4.75 0 2.64 5.68 0 7 3.75 0 2.11.447 5-1 1.3 2.596.25 2 3 2 0 7.267-1.09 11.09-6 16l-2-1 1-2c-2.67-1.333-1.33-1.333-4 0 1.84-2.755 2.57-7-2-7Z"
          />
          <path
            fill="#9d51f3"
            stroke="#9d51f3"
            d="M1303 313c-1.25-4.992.84-5.687 3-10l-2 1v-4h-4c0-4.202-.83-2.445 3-5l1 3 2-1c-4.4-8.791 12.07-.132 15-6h-2l5-1-1 4 3-1c0 2.654-.82 4.648-2 7l3 1c1.52-3.032.45-4.447 3-7 6.25 3.127 6 5.515 6 14-4.85-3.236-3.7 1.151-8-1-4.69 9.384-14.46 5.38-25 6Z"
          />
          <path
            fill="#b77ff3"
            stroke="#b77ff3"
            d="M1040 265v-6h-2c1.51-3.018 3.38-7.691 6-9v3h3c0-2.951 1.68-2.37 3-5 17.31 8.653-14.51 20.153 17 25-6.26 3.129-12.35-2.652-18 3l-1-3h-2c0-2.74.02-4 3-4-2.76-1.38-3.43-2.147-2-5-5.05 0-2.74-.422-7 1Z"
          />
          <path
            fill="#c89cf6"
            stroke="#c89cf6"
            d="M1399 92c3.85-5.135 12.96-6 20-6v2c6.05 0 5.95-2 12-2v2c6.47 0 21.51.026 25 7-9.86 0-14.46-.866-23-3-.67 1.333-1.33 2.667-2 4h4v2c-3.44 0-5.59 1.147-9 2 0-6.57-20.84-5.948-27-8Z"
          />
          <path
            fill="#c08ff3"
            stroke="#c08ff3"
            d="M1505 264c-2.01-4.015-2.33-3.164-6-5 4.91-2.455 2.97-4.985 7-7-1.28-7.673-.6-4.015-2-11 11.45-1.432 7.23 1.574 11-11 3.76 1.879 2.04 2.76 7 4 0 8.835-4 4.642-4 12h2c-.73 3.664-2 6.392-2 10h-2v-4c-4.66 2.33-6.8 8.639-11 12Z"
          />
          <path
            fill="#bc87f4"
            stroke="#bc87f4"
            d="M603 236v-8l1 3c1.837-5.511 8-13.362 8-2h2c1.256 5.023.565 2.696 2 7h2v-3h-2c0-6.054-.527-3.419 1-8 3.374 0 1.353-.162 6 1v-5c-10.775-2.155-31-6.492-31 9h-2c0-4.054.316-2.051-1-6-3.704 0-6.231-.538-8 3h2c-1.056 3.169-2.388 5.306 1 7l-2 1h4l-1 2c14.027 0 8.055.658 18-1Z"
          />
          <path
            fill="#b378f4"
            stroke="#b378f4"
            d="M734 282v2c-4.569 0-2.431 6-7 6v-2c-3.193 1.596-1.255 1-6 1 3.527 3.527 2.368 1.735 4 5-4.316 2.158-10-4.702-10 3l-3 1c0-4.754-7.473-6.946-10-12-3.247.812-7.071 1.536-10 3v-2c-3.556 0-4-.335-4-4l3-1-1 3 2 1c3.17-6.341 26.47-1.765 32 1 1.76-7.042 2.295-6.101 10-5Z"
          />
          <path
            fill="#c292f2"
            stroke="#c292f2"
            d="m531 314 1-2c-4-1.333-2.667 0-4-4h-4v-4h-3v-2h-2c0-3.374.162-1.353-1-6h-2c0-3.745-.894-2.553 2-4 2.155 6.466 15.2 24.4 24 20v2c3.745 0 2.106.447 5-1-1.947 3.893-5.415 3.195-9 2v-2c-3.491 1.745-1.255 1-7 1Z"
          />
          <path
            fill="#d2aef5"
            stroke="#d2aef5"
            d="M538 315v-2c-2.596 1.298-2 .255-2 3h3l-1 2c9.386 0 22.391 1.13 31 4v2c7.108 0 19.06-5.03 27-9l-1-3c-6.167 3.083-11.833 2.916-18 6-6.171-6.171-28.026.658-39-3Z"
          />
          <path
            fill="#c9ffde"
            stroke="#c9ffde"
            d="m244 307 164-1v2c-54.695 0-109.693 5.788-164-1Z"
          />
          <path
            fill="#e3cdf8"
            stroke="#e3cdf8"
            d="M1158 288c-.67-1.333-1.33-2.667-2-4-2.75 2.745-1.11 1.702-5 3-3.84-6.401-5.94-7.569-7-15h-2v-11l4-1c0-4.83-.61-9.386 3-13-2.28 6.847-1.17 1.96 1 15 6.17 0 7.92 13.151 6 17 4.39 2.193 2 .255 2 9Z"
          />
          <path
            fill="#ba84f4"
            stroke="#ba84f4"
            d="M824 166c0-7.783 1.213-13.724 0-21 3.193-1.596 2-.255 2-5h2v2h3c0 3.054-.211 1.368 1 5h2c.69 3.452 3.449 7.102 2 10h2v3c3.054 0 1.368-.211 5 1-1.362 5.446-1.615 2.771 1 8-2.809 1.405-1.65 2.301-3 5-2.258-7.904-6.673-8.019-9-15-2.745 0-1.702.596-3-2-3.902 1.951-1.906 5.906-5 9Z"
          />
          <path
            fill="#c191f6"
            stroke="#c191f6"
            d="M1260 97c-5.89-1.179-26-5.65-26 4-3.05 0-1.37.211-5-1v-2h-9v-2h-5c1.24-2.479 1.03-4 4-4 0-7.697 5.45-5.245 13-6v3c6.17-3.087 1.25-1 16-1v2h10c0 5.54 2 2.92 2 7Z"
          />
          <path
            fill="#b57cf4"
            stroke="#b57cf4"
            d="M1260 96c0 8.673 4.07 24-12 24v-2l-3 1c-2.09-4.17-.8-1.284-3-9h-2v-2h-2v-4c-2.54 0-2.82.555-4-3-3.09-9.267 22.31-4.385 26-5Z"
          />
          <path
            fill="#c08df6"
            stroke="#c08df6"
            d="M1570 100c4.49-2.243 24.35-10.697 19 0h2c0 2.745.3 1.404-1 4 3.75 0 2.55.894 4-2v9h3v-3c3.7 0 1.35.131 7-1v4c-19.62 1.033-14.47 3-28 3 0-4.808-3.88-8.558 1-11l-3-1v-2h-4Z"
          />
          <path
            fill="#c090f4"
            stroke="#c090f4"
            d="M988 285c-2.963 0-4.762 2.19-8 3v-4h-2v-2h-4l1-3 1 2v-5h-2c2.067-6.201 2.85-3.425 8-6v4h2v2c6.433 2.144 5.445 12.448 6 18h2c0 8.098-2 4.164-2 10h-8c-2.229-8.917 7.84-6.117 6-19Z"
          />
          <path
            fill="#dcc2f5"
            stroke="#dcc2f5"
            d="m864 250-2-6h-2v-10h-2v-2h-4v-8h-4c0-6.18-.615-17.872 8-15 0 4.466 1.097 6.611 0 11h6v2c-3.894 1.298-2.255 1.745-5-1l-1 3h4v6h2c0 7.686 1.483 12.586 0 20Z"
          />
          <path fill="#25cbba" stroke="#25cbba" d="M402 294H252v-4h2v2h148v2Z" />
          <path
            fill="#ab68f3"
            stroke="#ab68f3"
            d="M1789 289c0-3.567 5.26-19.086 8-20 1.63 4.888-.51 8.164 5 10 0 4.115 1.24 3.24 4 6l-2 3-3-2c-1.22 2.446-3 3.205-3 6-6.71 0-5.06.742-9 6l-3-1c0-3.705-1.45-8 3-8Z"
          />
          <path
            fill="#f9f2fd"
            stroke="#f9f2fd"
            d="M872 146v-2h-8v-6c-2.745 0-1.702-.596-3 2l-1-3-2 1v-4h-2v-6h-2c2.471-2.471 2-1.057 2-4h-4l-1-3-2 2c3.685 7.37 7.293 14.878 10 23h13Z"
          />
          <path
            fill="#ad6cf3"
            stroke="#ad6cf3"
            d="M1238 253c0-8.801 8.64-17.422 7-24l11-1v8h2c1.16 4.642 3.56 8.315 2 13-6.73-2.244-16.96-1.037-22 4Z"
          />
          <path
            fill="#a054f4"
            stroke="#a054f4"
            d="M1364 316c2.88 0 7.63-2.876 11-4-5.4-2.702.87-6.435 4-8v2h2v-6c6.44 9.66-15.5 20 5 20-2.75 5.502-17.71 9.158-20 0h-2v-4Z"
          />
          <path
            fill="#ab67f2"
            stroke="#ab67f2"
            d="M1490 160v-3l-2 1v-8c-5.56 0-4.47-1.414-6-6h-2l2-1c-1.3-3.894-1.75-2.255 1-5l-2-2c-1.89 3.789-.25 2-7 2 2.94-1.471 1.76-.293 3-4h-2v-2c-3.2 0-1.45-.37-5 2h3c-2.94 1.471-1.76.293-3 4h2v5c4.56 1.52 3.19 5 8 5v2c4.3 0 5.31 6.544 6 10h4Z"
          />
          <path
            fill="#dac1f3"
            stroke="#dac1f3"
            d="M1043 96c0 3.775 2.86 11 7 11v5h4c0 8.456-2 15.099-2 24l-2-1c2.26-4.51-.81-14.807-4-18 3.94-7.873-11.69-16.653-3-21Z"
          />
          <path
            fill="#bb86f3"
            stroke="#bb86f3"
            d="M820 204c0-13.671-5.114-28.773 1-41l1 2 1-5c.195 5.449-6.095 32 5 32v2h2c-4.764 2.382-8.865 10-10 10Z"
          />
          <path
            fill="#b2f9cd"
            stroke="#b2f9cd"
            d="M240 132h-4v-2h-2V96h-6v-3l4-1v-3l4-1c0 14.267 1.208 27.735 2 42h2v2Z"
          />
          <path
            fill="#e6d2f9"
            stroke="#e6d2f9"
            d="M1774 239h-2c0-3.054.21-1.367-1-5h-3v-2h-6c0-10.055-.95-6.154 1-12-3.81-1.907-1.88-.265-3-7 3.23-1.615 1.82-.277 3-5 1.59 4.767 9.47 18.767 11 18v2l3-1c-2.72 3.623-5 3.912-5 8h2v4Z"
          />
          <path
            fill="#f9f1fd"
            stroke="#f9f1fd"
            d="M1580 148v4h4c0 6.526-6.68 5.384-7 8-1.28 10.594-.67 21.333-1 32l2-1v2c-8.77-2.925-6.17-45 2-45Z"
          />
          <path
            fill="#a155f4"
            stroke="#a155f4"
            d="M1383 113h-2c4.57-1.524 5-2.077 5-7h2v8c3.83-2.555 1.8-2 6-2 0 2.943.47 1.529-2 4l2-1v2h3c0 5.104 2.35 10.81 3 16l-1-5c-6.03 2.011-3.94-.886-6-5l-3 1c0-5.777-.51-6.83-6-5-1.31-2.629-2.38-3.245-1-6Z"
          />
          <path
            fill="#b77ef4"
            stroke="#b77ef4"
            d="M670 112c0-3.745-.894-2.553 2-4v3h2c-1.251 2.502-3.03 4.03-5 6 2.871 1.436 1.577 2.577 4 5l2-3c1.18 3.541.866 4.799 3 8-3.987-1.994-3.834 1.417-7 3h3c0 2.745.298 1.404-1 4l-1-2c-5.706 2.853-5.826 5.348-3 11-6.127 3.063-8.917-31 1-31Z"
          />
          <path
            fill="#bef6d4"
            stroke="#bef6d4"
            d="M240 304h-10c0-16.435.956-34.823 5-51 3.473 10.419 2.4 26.206 3 37h2v14Z"
          />
          <path
            fill="#ac6af4"
            stroke="#ac6af4"
            d="M1162 227h2c-1.29 5.166-.24 2.856-3 7-6.25-2.083-7.2 0-13 0 0-13.114-.3-4.394 3-11-2.97-2.972-1.77-1.085-3-6 2.6-1.298 2-.255 2-3h-2c0-9.745-2.68-7.658 2-10 1.13 10.187.75 11.688 10 14l-1 3c2.6-1.298 1.25-1 4-1 0 5.054.42 2.735-1 7Z"
          />
          <path
            fill="#cba4f6"
            stroke="#cba4f6"
            d="M1784 291c-1.55-7.737 2.78-8.877 1-16h-2l1-3h-4c0-11.974 2-5.974 2-14-5.02-1.672-5-3.092-5-8l3 1v5c4.05 0 2.05-.316 6 1 0 4.463-2.57 8.722-4 13h6c-3.74 1.868 1 14.217 1 19-3.36 0-1.64 2-5 2Z"
          />
          <path
            fill="#c89bf6"
            stroke="#c89bf6"
            d="m1185 89 2-3c3.71 1.236 2.53.057 4 3 4.63-4.63 17.05-5 23-5l-1 2c8.6 0 9.57.943 19 0v3c2.94-1.471 1.29-.764 5-2l-1-3h-9c4-1.333 2.67 0 4-4-16.09 0-25.88 4-38 4l2-1c-4.33-1.084-9.51 1.26-12 5l2 1Z"
          />
          <path
            fill="#c08ff5"
            stroke="#c08ff5"
            d="M1366 336v-6h-2c-1.19-8.36-.43-4.714-2-11l2-1v2h2c.67 2 1.33 4 2 6 4.41 0 15.85-6.3 18-2l-2 1c2.6 1.298 2 .255 2 3h2c-7.53 2.511-12.6 10.351-22 8Z"
          />
          <path
            fill="#c396f4"
            stroke="#c396f4"
            d="M738 174c-8.761 0-9.608-4.797-18-2 0-2.764-1.315-5.259-2-8-3.052 0-5 .443-5-3h-2c0-7.219 4.962-4.259 10-3l-1 2h6v2h2v2h2v2h2v3c2.899 0 3.805 2.805 6 5Z"
          />
          <path
            fill="#c79df2"
            stroke="#c79df2"
            d="M538 80c5.696-11.392 25.263-4 38-4 0 9.609-16.665 4.698-23 5l1 3c-3.708 0-1.588 2-6 2 0-5.368-6.011-4.67-10-6Z"
          />
          <path
            fill="#d1acf6"
            stroke="#d1acf6"
            d="M1370 174v-2l-2 1c0-10.376 2-3.595 2-17h-2v-5c2.75 0 1.7-.596 3 2l2-3c2.91 1.939 3.86 20.834 3 26h4c1.4 5.617 2.1 3.175-3 7l1 2-2 1c0-6.536.64-10.341-6-12Z"
          />
          <path
            fill="#b478f2"
            stroke="#b478f2"
            d="M582 300c2.266 4.533-.805 4-5 4v2c-3.955 1.318-5.43-.215-9-2 0 4.054-.316 2.051 1 6l-3 1c-1.38-4.14-.415-2.123-3-6l-1 2c-2.931-1.466-3.833-1.056-7 0v-2l-3 1 1-3-5-1c5.21-10.419 24.366 1.211 34-2Z"
          />
          <path
            fill="#a45cf4"
            stroke="#a45cf4"
            d="M1154 264c2.68-1.789 5-3.23 5 1 2.51-5.024-2.73-15.356-4-23h-2l1-2c3.23 1.615 1.28.819 6 2v2c2.75 0 1.4.298 4-1v9h2c0 3.374.16 1.354-1 6h2c0 3.832 2 5.004-1 8h2c0 3.358-2 1.642-2 5-4.05 0-2.05.316-6-1v-2c-5 0-4.06-.126-6-4Z"
          />
          <path
            fill="#ab6df0"
            stroke="#ab6df0"
            d="M618 251c1.321-3.964.015-5.941-1-10-1.298 2.596-.255 2-3 2v-3l-4 2c-.939-2.818-1.061-5.182-2-8h-4c0-6.388 8-17.672 8-5h2c1.256 5.023.565 2.696 2 7h4c-1.952 3.904 3.88 15-2 15Z"
          />
          <path
            fill="#d1b0f4"
            stroke="#d1b0f4"
            d="M1303 314c16.74 0 13.61 4.77 17-2 4.96 1.654 6-1.007 8-5 3.08 1.538 1.38 1.413 5-1l2 2c-3.26 3.259-3.13 6.253-5 10 4.75 0 3.4-1.193 5 2h-9v-2h-3v-2l-20-2Z"
          />
          <path
            fill="#26cabb"
            stroke="#26cabb"
            d="M400 292c0-16.014-12.323-40.838 2-48v28h2v22h-2v-2h-2Z"
          />
          <path
            fill="#9d50f3"
            stroke="#9d50f3"
            d="M1126 278c-5.11 0-5.03 6-10 6 0-5.656-1.39-3.17-3-8-7.63 0-10.86-2.427-13 4l2-1c0 2.943.47 1.529-2 4-3.52-1.76-1.27-.854-7-2 0-8.173 8.62-6.207 14-8v2c35.03 0 27.52 4.68 19-1v4Z"
          />
          <path
            fill="#e4cbf7"
            stroke="#e4cbf7"
            d="M574 80c2.667-1.333 1.667-.333 3-3 9.031 3.01 18.52 5.78 24 14l-2 2c-4.164-8.327-17.109-10.37-25-13Z"
          />
          <path
            fill="#dbbef9"
            stroke="#dbbef9"
            d="m1220 316-1-2c-2 4.009-7.91 1.956-12 4-1.66-3.329-3.47-14.235 3-11l-1 2c4.02 0 4.91-3.717 6-7 1.33 2.667.33 1.667 3 3l1-2c2.93 1.465 2.15 3.61 3 7 6.45 0 2.83-2 10-2v10h-2v-2h-2v-2h-3v-2c-2.47 1.233-2.53 2.767-5 4Z"
          />
          <path
            fill="#c496f5"
            stroke="#c496f5"
            d="M829 129c0-6.887-7.832-8.168-2-14 1.628 3.257 1.015 4 5 4-3.487-1.744-1.14-4.14-4-7 2.527-2.527 1.578-1.157 3-4 2.694 1.347 3.879 0 7 0v2h2v2c4.811 1.604 3.863 5.454 5 10-2.745 0-1.404-.298-4 1 1.298-2.596 1-1.255 1-4l-2 1c0-3.443-1.948-3-5-3-1.358 4.073-1.948 9.974-6 12Z"
          />
          <path
            fill="#9d5ce9"
            stroke="#9d5ce9"
            d="M1675 316c-13.43 2.238-26.4 3.236-40 2 2.5-4.998 10.41-5 16-5v2l3 1c0-6.593 9.27-8 14-8v2c-4.11 0-3.24 1.24-6 4 2.72 1.362 9.61 1.435 13 2Z"
          />
          <path
            fill="#b779f8"
            stroke="#b779f8"
            d="M874 284h-2c0-7.666 1.452-12.741 0-20h-4l2-1-1-3c2.953-1.968 4.347-6 8-6 0 2.943.471 1.529-2 4l4 1c-2.533 5.065-.892 9.324 1 15h2c-7.621 2.54-6.743-.055-8 10Z"
          />
          <path
            fill="#b780f3"
            stroke="#b780f3"
            d="m1653 218 1-2h-6v-2c-6.03 0-2.68.219-10-1 0-3.762 4.86-4.216 8-5v2c2.49 0 9-7.998 9-1l5 1v2h2v2h2c0 4.745 1.19 3.404-2 5l1 2-5 1v-2h-2v-2h-3Z"
          />
          <path
            fill="#a35af4"
            stroke="#a35af4"
            d="M1154 157h-2c0-4.426 1.48-11.575 0-16 5.43-2.717 1.16-10.58 6-13 0 4.815 1.62 8.128 0 13h-3l2 1-2 2c1.3 2.596.25 2 3 2v2h2l-1 2c2.06 2.064 2.11 4 5 4 0 5.32 1.43 8-4 8v-2c-6.32 0-4-2.943-4-10-3.79 1.894-2 .255-2 7Z"
          />
          <path
            fill="#b984ef"
            stroke="#b984ef"
            d="M1655 108c2.38-2.381 3.8-3.601 7-2 1.47-2.943.76-1.292 2-5h-2l2-1-1-3h-2c4.5 0 9.71-.57 14-2v3h5v3c9.82 0 .72 6.86-7 3-3.8 7.609-7.26 4-18 4Z"
          />
          <path
            fill="#d7baf4"
            stroke="#d7baf4"
            d="M1168 237h-4c0-3.806 1.35-7.102 2-11l-2-1c1.25-3.757 2.75-3.243 4-7 3.79 1.894 2 .255 2 7l3 1c0 11.884-1 24.513-1 37-2.9-1.452-4-20.745-4-26Z"
          />
          <path
            fill="#bb83f7"
            stroke="#bb83f7"
            d="M656 272c1.471-2.943.764-1.293 2-5h-2c0-7.767 8.141-7.281 11-13 0 3.768 2.747 6.507 1 10h8v5l-3 1c0-2.745-.298-1.404 1-4-3.467 0-9.069 5.069-12 8v-2c-3.229 1.615-1.277 1.181-6 0Z"
          />
          <path
            fill="#9745f2"
            stroke="#9745f2"
            d="m660 273 2-1v2h2c0-3.877 6.739-8 10-8-1.298 2.596-1 1.255-1 4-3.202 0-1.63-.555-4 3 3.969 1.323 4 1.895 4 6-3.949 1.316-1.946 1-6 1 1.447-2.894 1-1.255 1-5-3.647 1.824-.281 6-5 6l-1 7h2c0 2.943 2 3.057 2 6-9.165 0-4.624-15.497-6-21Z"
          />
          <path
            fill="#bf8df2"
            stroke="#bf8df2"
            d="M740 217c-1.471-2.943-.764-1.293-2-5h-4l3-3-3-1v-2c-2.74 0-4-.024-4-3l-2 1c0-4.745-.596-2.807 1-6l-6-1c3.146 0 6.609-.218 8-3l1 2 2-1c0 5.37 3.747 8.495 6 13l-2 2h2v7Z"
          />
          <path
            fill="#a35cf4"
            stroke="#a35cf4"
            d="M1787 297c5.12 0 5.64-5 12-5 3.25-13.014 5.76-.214 7 6h2c0 3.202.37 1.445-2 5l-1-3c-4.69 0-5.17 2.208-10 1l2 2c-2.89 1.447-1.25 1-5 1v-3c-3.19 1.596-1.25 1-6 1l1-5Z"
          />
          <path
            fill="#aa65f6"
            stroke="#aa65f6"
            d="M1160 244v-2c-5.05 0-2.74.422-7-1 2.69 9.401 7 16.324 7 24-2.01-4.021-3.63-2.685-7-1-1.88-3.76 1.41-7.77 0-12h-2c0-4.054.32-2.051-1-6h3c-3.2-6.404-1.82-2.521-3-12 4.78 0 5.09-1.477 11 0 0 3.684 3.22 7.891-1 10Z"
          />
          <path
            fill="#d9bef5"
            stroke="#d9bef5"
            d="M1548 155c-1.15-5.731-.24-3.48-2-7l-2 1v-5h-2c0-12.882 4-19.375 4-28h-2c0-7.745-2.09-5.956 2-8v4h2v2h2c0 5.131-2.58 7.842 0 13-6.62 6.616-2 18.643-2 28Z"
          />
          <path
            fill="#923cf2"
            stroke="#923cf2"
            d="m1381 232 1 2v-2c3.06 0 6.7-1.403 8-4 1.61 3.229 1.18 1.277 0 6h3c0 6.528-6.74-.527-9 4-1.92 3.841-1.07 9.534-6 12-3.64-7.283-.81-11.651 3-18Z"
          />
          <path
            fill="#af6ff3"
            stroke="#af6ff3"
            d="m1261 277-1-5h-3l-1 4h-3c0-5.892 5-12.504 5-18h-2l2-2c-2.67-4-2.67-2 0-6 5.22 2.61 3.82 16.818 8 21-3.18 3.179-2 1.057-2 7l-1-2-2 1Z"
          />
          <path
            fill="#a156f3"
            stroke="#a156f3"
            d="M1468 262c0-3.578 10.4-15.2 14-17 0 4.7-3.84 5.476-2 11h7c-5.8 2.9-8.09 3.091-13 8-2.67-1.333-1.67-.333-3-3l-3 1Z"
          />
          <path
            fill="#e3cdf7"
            stroke="#e3cdf7"
            d="M1257 211c-3.45-6.908-14.71-6.213-21-7v-2c-15.11 0-11.34 2-19 2 0 3.178 1.39 3.306 4 2l-1 2c8.8 0 28.59-2.607 37 3Z"
          />
          <path
            fill="#913bf0"
            stroke="#913bf0"
            d="M876 248c4.328-2.164-.328-5.836 4-8 0 5.745.745 3.509-1 7 4.916 0 6.393-2.821 5-7h-2v-4c4.304-1.435 2.744.023 4-5 4.522 9.043 3 8.762 3 20l-1-2-2 1 1 2c-3.161 3.161-5.555 2.332-8 6-1.092-8.739-2.202-5.596 0-10h-3Z"
          />
          <path
            fill="#ad6df1"
            stroke="#ad6df1"
            d="M1707 296c-3.79-7.583-15.69-8.462-23-7l1-3c-4.69-3.125-3.33 0-8 0l-1 4c4.09-2.046 4.63.743 3 4 2.75 0 1.7-.596 3 2 9.9-3.301.24-2.66 19-4v2c4.41 0 2.29 2 6 2Z"
          />
          <path
            fill="#f4fff6"
            stroke="#f4fff6"
            d="M250 76v-2c12.667 0 25.35.649 38 0 10.673-.547 21.313-2 32-2v2h16v2h-86Z"
          />
          <path
            fill="#e3cff3"
            stroke="#e3cff3"
            d="M1678 105v3h4v2c-4.96 0-13.92-.719-18 2v-2h-26c10.63-2.126 31.96-7.681 40-5Z"
          />
          <path
            fill="#9e54f2"
            stroke="#9e54f2"
            d="M1153 187c0 8.355-1.78 15.873 0 23h2v2h2v2c2.75 0 1.7-.596 3 2l-4 2c-9.03-9.028-8.33-20.343-3-31Z"
          />
          <path
            fill="#fdfafb"
            stroke="#fdfafb"
            d="M1703 310v-3l1 9c-5.84 0-1.9 2-10 2v-2h-2v-2l-3 2h2v2c-5.54 0-2.92 2-7 2-1.54-4.612.03-2.793-6-4 8.38-1.677 17.42-6 25-6Z"
          />
          <path
            fill="#a45fed"
            stroke="#a45fed"
            d="m1405 180-4-2 1-4c-10.67 0-8.33-2.668-6-12h-2c2.4-4.806 5.53-5.065 8-10v2h2c0 8.432 1.67 13.639 0 22h2l-1 4Z"
          />
          <path
            fill="#fefdfd"
            stroke="#fefdfd"
            d="M1073 256h15v12h-24c1.45-2.894.25-2 4-2v4c3.61 0 11.12-3.39 16-4v-4h-12l1-6Z"
          />
          <path
            fill="#7fedab"
            stroke="#7fedab"
            d="M394 76v2H248c.333-.667.255-1.99 1-2 48.329-.662 96.667 0 145 0Z"
          />
          <path
            fill="#9a4af0"
            stroke="#9a4af0"
            d="M934 147c-1.267-6.337 6.451-24-2-24v-2c-2.843 1.422-1.473.473-4 3l-4-2c-1.319 5.275-1.618 6 4 6v2h2c1.325 6.626-4.18 12.91 4 17Z"
          />
          <path
            fill="#b272f8"
            stroke="#b272f8"
            d="m873 252-1-2c-5.333 1.333-2.667 1.333-8 0 0-3.596 1-5.541 1-9h5c1.465-4.396-.608-6.824-2-11 6.52 0 6.333 3.167 8 9l3-1c-2.194 6.581-3.146 8.292-6 14Z"
          />
          <path
            fill="#dabbf8"
            stroke="#dabbf8"
            d="M1381 332c4.04-1.347 2.75-3 7-3-2.6-1.298-2-.255-2-3h-2c2.4-4.798 4.28-3.64 9-6l1 2c1.6-3.193.25-2 5-2v3c4.31-2.153 9-3.966 9 2-4.84 0-14.58 1.305-16 7h-2v-2c-4.11 2.054-1.26.895-9 2Z"
          />
          <path
            fill="#9ef5bd"
            stroke="#9ef5bd"
            d="M240 240c0-16.419 3.221-16 20-16 0 7.498-13.901 14.983-20 16Z"
          />
          <path
            fill="#e0caf4"
            stroke="#e0caf4"
            d="M1621 317c-30.43.845-28.52 3-49 3v-2h-6c16.42-5.474 38.46-4.307 55-1Z"
          />
          <path
            fill="#27e48b"
            stroke="#27e48b"
            d="M252 294h-4c0-13.35-9.941-34.03 2-40v18h2v22Z"
          />
          <path
            fill="#ad6bf8"
            stroke="#ad6bf8"
            d="M1364 316c3.38-6.764 9.45-12.45 15-18 1.91 3.814.88 1.264 2 8h-2v-2c-2.99 2.991-6 2.52-6 7h2c-3.03 1.517-8.13 5-11 5Z"
          />
          <path
            fill="#bc85f7"
            stroke="#bc85f7"
            d="M1164 227h-2l1-3c5.46 3.64 2.31 7.755 1 13h4c0 12.017 2 9.973 2 25h-2c0-2.74-.02-4-3-4 0-4.054-.32-2.051 1-6h-2v-9h-2c0-6.863 2-9.739 2-16Z"
          />
          <path fill="#2ced7c" stroke="#2ced7c" d="M402 294v2H252v-2h150Z" />
          <path
            fill="#9747f0"
            stroke="#9747f0"
            d="M1076 290c0 5.542-2.37 4.503-1 10h9v2h-16c0-7.604-.95-4.474-6-7l1-2-2-1c4.14-1.38 4.59.897 9 2v-2h-2c1.83-3.667 4.54-3.153 8-2Z"
          />
          <path
            fill="#a35eef"
            stroke="#a35eef"
            d="M1511 137c-5.6 3.736-6.73 0-11 0v-5c-4.05 0-2.05-.316-6 1-1.47-2.943-.29-1.764-4-3 6.68-13.352 12.94 2.968 21 7Z"
          />
          <path
            fill="#fdfafc"
            stroke="#fdfafc"
            d="M822 298c6.295-6.295 2.784-16.568 7-25l1 4h2c-1.256 5.022-.565 2.696-2 7h2c0 9.724-2 .316-2 18h-4v-4h-4Z"
          />
          <path
            fill="#9645f1"
            stroke="#9645f1"
            d="M1498 176v-4c-2.6 1.298-1.25 1-4 1 0-4.079-1.68-3.517-4-7h2v2h2v-7c4.77 0 9.51-2.244 14 0-2.13 4.256-1.52 4.011-6 7 2.28 5.692.39 4.197 4 6-2.6 1.298-5.08 2-8 2Z"
          />
          <path
            fill="#bd87f5"
            stroke="#bd87f5"
            d="m929 165 3-1-4-1c0-3.628-.621-7.19 3-9-1.081-3.243-1.169-6 3-6 1.181 4.723.385 2.771 2 6-3.056 1.528-3.854 26.805-4 29-2.059-6.178-1.151-12.452-3-18Z"
          />
          <path
            fill="#eee5f7"
            stroke="#eee5f7"
            d="M1328 278v2l4 1c-2.92 4.375-4.59 1.592-8 5h2v2l-20-1v-3h-2v-3c16.02-2.003 1.32-3 24-3Z"
          />
          <path
            fill="#cba4f4"
            stroke="#cba4f4"
            d="M1782 192h4c0 12.491-1.64 7.721 2 15-3.41 3.411-5.49 8.497-10 10l-1-7c3.71-1.236 2.06-.529 5-2-1.18-5.912-1-10.03 0-16Z"
          />
          <path
            fill="#fdfafc"
            stroke="#fdfafc"
            d="M1509 260c0 2.93 2.56 6-2 6-1.98 7.924-5 4.588-5 14h-6c0-9.261 6.47-13.468 13-20Z"
          />
          <path
            fill="#9d50f4"
            stroke="#9d50f4"
            d="M1042 304c1.18-4.723.39-2.771 2-6-4.08-1.359-6.38.23-11 1-1.24-3.727-2.22-7.118-3-11-4.98 2.491-2 .255-2 11 6.08 2.028 7.22 4.031 14 5Z"
          />
          <path
            fill="#c69bf4"
            stroke="#c69bf4"
            d="M1187 110v-2h-3c0-7.123-.48-14.741 11-9l2-3c2.76 2.761 2.58 4.719 6 7-8.33.757-13-1.333-13 7h-3Z"
          />
          <path
            fill="#c194f3"
            stroke="#c194f3"
            d="M720 308c2.667 1.333 1.667.333 3 3l-18 1 7-1c-10.482-1.165-6.3.35-13-3 3.269-3.269 1.125-1.65 7-4l1 2 1-2v2h2v2c2.975 0 6.648-4.648 9-7 0 3.943-.707 2.293 2 5l-1 2Z"
          />
          <path
            fill="#eedaf5"
            stroke="#eedaf5"
            d="M1675 316c-2.23.893-3.6 3.909-6 4-17.32.654-34.67 0-52 0 2.89-5.773 45.99-.569 58-4Z"
          />
          <path
            fill="#af6ef4"
            stroke="#af6ef4"
            d="M1754 182v-3h-2c0-3.202-.37-1.445 2-5l1 2c1.15-5.731 1.76-3.48 0-7 4-1.333 2.67 0 4-4 1.73 3.451 1.03 4.677 5 6v4h2v3c-3.95 1.316-1.95 1-6 1v-2c-3.75 0-2.55-.894-4 2h2c-2.37 3.555-.8 3-4 3Z"
          />
          <path
            fill="#ba80f7"
            stroke="#ba80f7"
            d="M682 170c0-2.905-4.205-11.411-6-15l2-1v2h2c0 4.027-.11 1.343 1 8 8.597 0 16.236 6 1 6Z"
          />
          <path
            fill="#ac6cef"
            stroke="#ac6cef"
            d="M1703 310c-2.8 0-8.32-4.773-12-6 0-9.414-1.31-10.743 10-12v2h3c-1.39 5.574.39 10.426-1 16Z"
          />
          <path
            fill="#a762f5"
            stroke="#a762f5"
            d="M952 241c-3.491-1.745-2-.255-2-6 4.552 0 8.713-.713 12-4 0 4.252-1.03 6.882 0 11h-3c-.857 4.284-3 4.872-3 8-2.23-3.346-6.202-4.595-4-9Z"
          />
          <path
            fill="#cea9f3"
            stroke="#cea9f3"
            d="M591 104c1.969-1.969 9.205-11 2-11 3.707-1.236 2.529-.057 4-3 1.512 3.024 2.822 2.467 4 6h2c0 4.028-.11 1.343 1 8-2.943 0-4 1.057-4 4-1.8-3.6-4.445-.815-8-2l1-2h-2Z"
          />
          <path
            fill="#dbbdf8"
            stroke="#dbbdf8"
            d="M1798 256c-2.67-1.333-1.33-1.333-4 0-1.12-3.346-.86-9-5-9-1.26 5.023.3 3.565-4 5 0-4.282 1.01-6.668 5-8l-3-1 3-2-3-1c5.73-1.146 3.48-.24 7-2v4h2v8h2v6Z"
          />
          <path
            fill="#e8d9f4"
            stroke="#e8d9f4"
            d="M1628 184c-1.97-1.973-3.54-2.771-6-4 .67-1.333 1.33-2.667 2-4-6.54 0-7.84 4-14 4v-2h-9l-1 4c9.07 0 8.27-.864 14 2l1-2c7.74 1.105 4.89 2.054 9 0v2h4Z"
          />
          <path
            fill="#f9ebfd"
            stroke="#f9ebfd"
            d="M1053 138h-2c1.3-2.596.25-2 3-2 0 16 .64 32.013 0 48-.21 5.371-2 10.625-2 16-2-20.009-1.26-41.616 1-62Z"
          />
          <path
            fill="#fdfcfc"
            stroke="#fdfcfc"
            d="M1336 308c-1.83-3.657 2-7.821 2-12 2.89 8.659 2.4-2 4 14h-3l-1 6h-7c0-3.915 1.86-5.905 5-8Z"
          />
          <path
            fill="#a364ef"
            stroke="#a364ef"
            d="M1026 236c-.71-15.716-1.83-30.673 2-46 1.24 3.707.53 2.057 2 5-2.8 1.4-4 23.951-4 31h2c0 5.429-2 5.335-2 10Z"
          />
          <path
            fill="#fbf4fb"
            stroke="#fbf4fb"
            d="M1257 227c2.47-2.471 1.06-2 4-2 0-2.943-.47-1.529 2-4l-1-2 2 7c-7.03 0-4.6 9.225-4 14h4c0 8.903-.9 3.691-3 10 0-5.412-1.74-18.487-4-23Z"
          />
          <path
            fill="#d4aff8"
            stroke="#d4aff8"
            d="M1226 304c0-5.081 4-5.081 4 0h2c0-4.746-.6-2.807 1-6 2.75 2.745 1.7 1.106 3 5h2c0-2.745-.6-1.702 2-3-1.3 2.596-1 1.255-1 4-3.2 0-1.63-.555-4 3l-2-1c-2.6 2.599-7.51 4-11 4 .8-3.219.44-6 4-6Z"
          />
          <path
            fill="#ad6af4"
            stroke="#ad6af4"
            d="M1584 314h-6v-2h-6c-.67-2-1.33-4-2-6h-3l1-4c5.19 0 8-3.63 8 6l7-1-3 3h4v4Z"
          />
          <path
            fill="#c08ef4"
            stroke="#c08ef4"
            d="M1805 306c-7.96 7.959-18 8.085-18-4 3.75 0 2.11.447 5-1v3c3.05 0 5 .443 5-3h-2l3-1 1 2c2.94-2.943 1.06-2 6-2 0 2.864-1.35 3.295 0 6Z"
          />
          <path
            fill="#c18ff6"
            stroke="#c18ff6"
            d="M494 168c0-5.744 2.973-11.218 2-19 2.667-1.333 1.667-.333 3-3 1.105 7.738-1.108 5.946 3 8l-2 2c1.298 2.596.255 2 3 2 0 4.334-1.124 7.247-3 11-2.246-1.123-3.532-1-6-1Z"
          />
          <path
            fill="#fcf4fd"
            stroke="#fcf4fd"
            d="m1221 316-1 4c-10.6-1.178-22.36 1.819-32-3 8.13-1.627 26.5 5.99 31-3v2h2Z"
          />
          <path
            fill="#fdfbfc"
            stroke="#fdfbfc"
            d="M1410 326c7.54 0 13.45.551 19-5 2.93 1.465 2.15 3.61 3 7-9.46 0-4.79 2-12 2v-2l-10-2Z"
          />
          <path
            fill="#a45ef4"
            stroke="#a45ef4"
            d="M1548 152h2v12c4.08 0 3.52-1.678 7-4 1.21 3.625 0 4.274 0 8-4.31 0-6.53-.395-8 4-1.06-17.998-1-11.324-1-20Z"
          />
          <path
            fill="#f9fdfc"
            stroke="#f9fdfc"
            d="M364 182c0-5-.62-10.039 0-15 .175-1.403 2.368-1.735 3-3l1 4-2 1c4.954 2.477 0 5.498 0 9h8v4h-10Z"
          />
          <path
            fill="#b278f2"
            stroke="#b278f2"
            d="M1050 188c-1.33-3.975-1.53-7-6-7l1-11 3 1-1-6h2l1 3h2c0 7.502-.01 13.028-2 20Z"
          />
          <path
            fill="#fdfdfc"
            stroke="#fdfdfc"
            d="M534 277c-4.758-4.758-7-10.448-7-18l1 5h6v2h2c0 10.745 2.981 8.509-2 11Z"
          />
          <path
            fill="#b980f3"
            stroke="#b980f3"
            d="M907 155c0-4.028.11-1.342-1-8 3.087-1.544 2.271-4.357 3-8 3.555 2.37 3 .798 3 4 3.745 0 2.106.447 5-1-1.295 2.59-1.295 3.41 0 6l-2 2-1-3c-2.894 1.447-2 .255-2 4-3.745 0-2.553-.894-4 2h2c-1.298 2.596-.255 2-3 2Z"
          />
          <path
            fill="#ae6cf4"
            stroke="#ae6cf4"
            d="M1375 149c-1.44-5.759-.13-9.939-1-16 4.4-2.202 1.91-.26 3-9 .31 3.433-1.57 13 4 13-2.49 4.971.36 9.88-6 12Z"
          />
          <path
            fill="#32aff2"
            stroke="#32aff2"
            d="M350 104v2h2c0 5.017 1.232 9.071 0 14h-8v-4h-2c0-8.62-.581-12 8-12Z"
          />
          <path fill="#f4fff4" stroke="#f4fff4" d="M388 94h-84v-2h84v2Z" />
          <path
            fill="#edd8f9"
            stroke="#edd8f9"
            d="M836 228c-2.303-13.82 2.07-30.057 3-44 0 13.582-3 31.97-3 44Z"
          />
          <path
            fill="#34e977"
            stroke="#34e977"
            d="M320 88v2h-70c.333-.667.255-1.979 1-2 22.991-.657 46 0 69 0Z"
          />
          <path
            fill="#f7f2f9"
            stroke="#f7f2f9"
            d="M842 172c3.479 6.957 5 11.003 6 20h-2v-2l-3 2-1-12h-2c1.122-6.735.093-4.187 2-8Z"
          />
          <path
            fill="#b577f8"
            stroke="#b577f8"
            d="m515 227 1 9h2c0 7.137 1.296 8-5 8-1.289-3.866.035-5.862-1-10h-2c3.333-6.667 1-5 5-7Z"
          />
          <path
            fill="#fefafc"
            stroke="#fefafc"
            d="m623 240 1 2-2 1c1.195 3.584 0 5.31 0 9h2c-1.081 14.051.374 8.877-2 16h-2c-1.201-3.603-1.184-25.211 3-28Z"
          />
          <path
            fill="#9e51f5"
            stroke="#9e51f5"
            d="m767 115-1-2-1 3h-3c-3.504-28.028 16.549-6.774 5-1Z"
          />
          <path
            fill="#b374f6"
            stroke="#b374f6"
            d="M1552 264c0-6.377 1.05-7.674 0-14 2.84-1.421 3.6-.598 6-3 1.65 8.269 1 3.3 1 15l-2-1-1 3c-2.67-1.333-1.33-1.333-4 0Z"
          />
          <path
            fill="#a865f2"
            stroke="#a865f2"
            d="M1232 221c-4.34 0-6.25-1.126-10-3l1-6c3.4 1.701 7.36-.271 11-1 0 5.836-2 1.902-2 10Z"
          />
          <path
            fill="#45b7f0"
            stroke="#45b7f0"
            d="M304 130c0 10.085 3.928 8-12 8 0-9.731 2.895-10.276 12-8Z"
          />
          <path
            fill="#fff8ff"
            stroke="#fff8ff"
            d="M1172 160h2c.86 20.708 0 22.851 0 41h-2c0-13.206 3.09-28.63 0-41Z"
          />
        </g>
      </svg>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'logo-gsmlg-dev': AppbarElement;
  }
}
